<template>
  <div>
    <el-dialog
      class="quotationDetail"
      :visible="innerVisible"
      :title="quotation.quotationNo || this.$t('Pricing.Quotation')"
      :width="isZh ? '1450px' : '1530px'"
      top="5vh"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div style="display:flex;flex-direction:column;">
        <el-form class="section">
          <el-row v-show="editing">
            <el-col :span="24">
              <el-button v-show="showDetail && canUpdate" no="onSave" type="success" @click="onSave">{{ $t('Pricing.Save') }}</el-button>
              <el-button v-show="canUpdate" no="onCancel" type="success" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
              <el-button v-show="showDetail" no="onPrint" type="primary" @click="onPrint">{{ $t('Pricing.Print') }}</el-button>
              <el-button v-show="$checkPermission(['module_RemoteBooking']) && quotation && quotation.uuid && !associatedInquiry" no="onRemoteBooking" type="primary" @click="onRemoteBooking">{{ $t('Pricing.RemoteBooking') }}</el-button>
              <el-button v-if="canUpdate && quotation.status2" :disabled="quotation.status2 === SystemConstants.QUOTE_STATUS_QUOTED.code" type="primary" no="submit" @click="editStatus(SystemConstants.QUOTE_ACTION_SUBMIT.code)">{{ $t('CargoMsg.Cargo_SubmitQuotation') }}</el-button>
              <el-button v-if="canUpdate && quotation.status2" :disabled="quotation.status2 === SystemConstants.QUOTE_STATUS_PENDING.code" type="primary" no="revoke" @click="editStatus(SystemConstants.QUOTE_ACTION_REVOKE.code)">{{ $t('CargoMsg.Cargo_WithdrawQuotation') }}</el-button>
              <el-button v-if="canUpdate && quotation.status2" :disabled="quotation.status2 !== SystemConstants.QUOTE_STATUS_PENDING.code" type="primary" no="refuse" @click="p => { refuseQuotationDialog.visible = true }">{{ $t('CargoMsg.Cargo_RejectQuotation') }}</el-button>
              <span no="status" style="margin-left: 15px;font-size:14px;color:red">{{ ColumnUtils.showTypeLabelFunc(quotation.status2, SystemConstants.QUOTE_STATUS) + (quotation.refuseReason ? ('(' + quotation.refuseReason + ')') : '') }}</span>
            </el-col>
          </el-row>
        </el-form>
        <!-- 客户信息 -->
        <el-form :label-width="isZh ? '110px' : '130px'" label-position="right" class="section" :disabled="associatedInquiry">
          <el-form :inline="true" :label-width="isZh ? '110px' : '130px'" label-position="right" :disabled="associatedInquiry">
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="0">
                  <span style="display: flex;">
                    <el-select v-model="quotation.clientType" no="clientType" :style="isZh ? 'width:85px;' : 'width:105px;'" :disabled="!editing" @change="ddlClientTypeChangeHandler">
                      <el-option
                        v-for="(item,index) in PriceConstant.CLIENT_TYPE_LIST"
                        :key="index"
                        :label="isZh ? item.chineseName : item.englishName"
                        :value="item.code"
                      />
                    </el-select>

                    <!--正式客户-->
                    <cargo-company-select
                      v-if="quotation.clientType === 1"
                      ref="quotationZsName"
                      no="clientId"
                      :disabled="!editing"
                      :custom-style="formItemWidth + 'padding-left: 5px;'"
                      :method-params="{customer:true,active:true}"
                      :default-value="quotation.clientId || undefined"
                      @change="onClientChange"
                    />

                    <!--临时客户-->
                    <cargo-advance-select
                      v-if="quotation.clientType === 0 && !associatedInquiry"
                      ref="quotationLsName"
                      no="clientId"
                      :disabled="!editing"
                      :custom-label="(item)=>`[${branchMap.get(item.branchId)}]${item.name}`"
                      :show-custom-label-in-option="true"
                      filterable
                      :default-value="quotation.clientId || undefined"
                      :cache="false"
                      tag-name="name"
                      tag-value="clientId"
                      :style="formItemWidth + 'padding-left: 5px;'"
                      :filter-tag-names="['code','name']"
                      :static-options="filter.clientList"
                      @parentCallBack="onClientChange"
                    />

                    <!--临时客户(询价)-->
                    <el-input
                      v-if="quotation.clientType === 0 && associatedInquiry"
                      ref="quotationLsName"
                      v-model="quotation.tempClientId"
                      no="clientId"
                    />

                    <!--新建临时客户-->
                    <span v-if="quotation.clientType === 0">
                      <img src="@/assets/add.png" :title="$t('Pricing.AddNewCustomer')" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" @click="onAddClient()">
                    </span>
                  </span>
                </el-form-item>
                <el-form-item :label="$t('Pricing.QuotationValidFrom')">
                  <span style="display: flex;">
                    <el-date-picker v-model="quotation.beginDate" no="beginDate" type="date" value-format="yyyy-MM-dd" :disabled="!editing" :clearable="false" :editable="false" />
                    <span style="padding-left: 4px;padding-right: 4px;"> - </span>
                    <el-date-picker v-model="quotation.endDate" no="endDate" type="date" value-format="yyyy-MM-dd" :disabled="!editing" :clearable="false" :editable="false" />
                  </span>
                </el-form-item>
                <el-form-item :label="$t('Pricing.BusinessType')">
                  <el-radio-group v-model="quotation.jobType" :disabled="!editing">
                    <div style="display: flex;">
                      <el-radio no="onCancel" :label="0">{{ $t('Pricing.jobTypeExport') }}</el-radio>
                      <el-radio no="onCancel" :label="1">{{ $t('Pricing.jobTypeImport') }}</el-radio>
                    </div>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Contact')">
                <el-input ref="quotationContact" v-model="quotation.contact" no="contact" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Phone')">
                <el-input ref="quotationPhone" v-model="quotation.phone" no="phone" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Fax')">
                <el-input v-model="quotation.fax" no="fax" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Email')">
                <el-input v-model="quotation.email" no="email" :disabled="!editing" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.PlaceOfReceipt')">
                <el-input v-model="quotation.receiptPlace" no="receiptPlace" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.POL')">
                <cargo-advance-select
                  v-if="quotation.type!=PriceConstant.QUOTATION_AIR"
                  ref="quotationSePol"
                  no="pol"
                  :disabled="!editing"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:100%;"
                  :default-value="quotation.pol"
                  @parentCallBack="p=>{polChange(p);}"
                />
                <cargo-advance-select
                  v-if="quotation.type==PriceConstant.QUOTATION_AIR"
                  ref="quotationAirPol"
                  no="pol"
                  :disabled="!editing"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:100%;"
                  :default-value="quotation.pol"
                  @parentCallBack="p=>{polChange(p);}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.POD')">
                <cargo-advance-select
                  v-if="quotation.type!=PriceConstant.QUOTATION_AIR"
                  ref="quotationSePod"
                  no="pod"
                  :disabled="!editing"
                  filterable
                  :placeholder="$t('Pricing.PODPrompt')"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:100%;"
                  :default-value="quotation.pod"
                  @parentCallBack="p=>{podChange(p);}"
                />
                <cargo-advance-select
                  v-if="quotation.type==PriceConstant.QUOTATION_AIR"
                  ref="quotationAirPod"
                  no="pod"
                  :disabled="!editing"
                  filterable
                  :placeholder="$t('Pricing.PODPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:100%;"
                  :default-value="quotation.pod"
                  @parentCallBack="p=>{podChange(p);}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.PlaceOfDelivery')">
                <el-input v-model="quotation.deliveryPlace" no="deliveryPlace" :disabled="!editing" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Goods')">
                <el-input v-model="quotation.goodsName" no="goodsName" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.HsCode')">
                <el-input v-model="quotation.hsCode" no="hsCode" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.FreightTerm')">
                <el-input v-model="quotation.freightTerm" no="freightTerm" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.BookingAgent')">
                <cargo-advance-select
                  no="bookingAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :disabled="!editing"
                  :method-params="{bookingAgent:true,active:true}"
                  :default-value="quotation.bookingAgent||''"
                  @parentCallBack="p=>{bookingAgentChangeHandler(p)}"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="quotation.type === PriceConstant.QUOTATION_LCL ? $t('Pricing.Weight_LCL') : $t('Pricing.Weight')">
                <el-input-number no="grossWeight" :style="formNumberWidth" :value="parseFloat(quotation.grossWeight) === 0 ? undefined : quotation.grossWeight" :disabled="!editing" :precision="3" :controls="false" :max="999999999" :min="-999999999" @blur="calculateChargeWeight()" @input="val=>{quotation.grossWeight=val!==0?val:undefined}" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Volume') + '(CBM)'">
                <el-input-number no="cubage" :style="formNumberWidth" :value="parseFloat(quotation.cubage) === 0 ? undefined : quotation.cubage" :disabled="!editing" :precision="3" :controls="false" :max="999999999" :min="-999999999" @blur="calculateChargeWeight()" @input="val=>{quotation.cubage=val!==0?val:undefined}" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Measurement')">
                <el-input v-model="quotation.size" no="size" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.ChargedWeight') + (quotation.type === PriceConstant.QUOTATION_AIR ? '(KG)' : (quotation.type === PriceConstant.QUOTATION_FCL ? '(T)' : '(R/T)'))">
                <el-input-number no="chargeWeight" :style="formNumberWidth" :value="parseFloat(quotation.chargeWeight) === 0 ? undefined : quotation.chargeWeight" :disabled="!editing" :precision="3" :controls="false" :max="999999999" :min="-999999999" @blur="syncChargeWeightToCharge()" @input="val=>{quotation.chargeWeight=val!==0?val:undefined}" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="quotation.type === PriceConstant.QUOTATION_FCL">
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Num20')">
                <cargo-input-number v-model="quotation.num20" no="num20" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="-999999999" @change="onNumChanged" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Num40')">
                <cargo-input-number v-model="quotation.num40" no="num40" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="-999999999" @change="onNumChanged" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.NumHC')">
                <cargo-input-number v-model="quotation.numHc" no="numHc" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="-999999999" @change="onNumChanged" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.Num45')">
                <cargo-input-number v-model="quotation.num45" no="num45" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="-999999999" @change="onNumChanged" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item>
                <el-checkbox v-model="quotation.dangerousGoods" no="dangerousGoods" :label="$t('Pricing.Hazard')" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.GoodsLevel')">
                <el-input v-model="quotation.hazardClass" no="hazardClass" :disabled="!(editing && quotation.dangerousGoods)" :maxlength="64" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.UnNo')">
                <el-input v-model="quotation.unNo" no="unNo" :disabled="!(editing && quotation.dangerousGoods)" :maxlength="64" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Pricing.quantity')">
                <el-input-number v-model="quotation.quantity" no="quantity" :style="formNumberWidth" :disabled="!editing" :precision="0" controls-position="right" :max="999999999999" :min="0" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('Payment.UserDefinedField1')">
                <el-input v-model="quotation.pricingUserDefinedField1" no="pricingUserDefinedField1" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Payment.UserDefinedField2')">
                <el-input v-model="quotation.pricingUserDefinedField2" no="pricingUserDefinedField2" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Payment.UserDefinedField3')">
                <el-input v-model="quotation.pricingUserDefinedField3" no="pricingUserDefinedField3" :disabled="!editing" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('Payment.UserDefinedField4')">
                <el-input v-model="quotation.pricingUserDefinedField4" no="pricingUserDefinedField4" :disabled="!editing" />
              </el-form-item>
            </el-col>
          </el-row>
          <!--询价相关信息-->
          <el-row>
            <el-col :span="6">
              <!--询价编号-->
              <el-form-item :label="$t('CargoMsg.Cargo_EnquiryNumber')">
                <el-input v-model="quotation.inquiryPriceNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--关联港前报价单号-->
              <el-form-item :label="$t('CargoMsg.Cargo_AssociatedPrePortQuoteNumber')">
                <el-input v-model="quotation.prePortQuotationNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--关联尾程报价单号-->
              <el-form-item :label="$t('CargoMsg.Cargo_AssociatedLastMileQuoteNumber')">
                <el-input v-model="quotation.lastMileQuotationNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--询价人-->
              <el-form-item :label="$t('CargoMsg.Cargo_Enquirer')">
                <cargo-user-select
                  :default-value="quotation.createdBy"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <!--货盘性质-->
              <el-form-item :label="$t('CargoMsg.Cargo_PalletType')">
                <cargo-advance-select
                  no="palletNature"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="quotation.palletNature"
                  :static-options="SystemConstants.PALLET_NATURES"
                  @parentCallBack="p=>{quotation.palletNature=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--货好时间-->
              <el-form-item :label="$t('SeaExport.CargoReadyDate')">
                <el-tabs v-model="quotation.cargoReadyTimeType" :disabled="associatedInquiry">
                  <el-tab-pane :disabled="!editing || associatedInquiry" :label="$t('CargoMsg.Cargo_Range')" :name="SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code" />
                  <el-tab-pane :disabled="!editing || associatedInquiry" :label="$t('CargoMsg.Cargo_Date')" :name="SystemConstants.CARGO_READY_TIME_TYPE_DATE.code" />
                </el-tabs>
                <cargo-advance-select
                  v-if="quotation.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code"
                  no="cargoReadyTimeRange"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="quotation.cargoReadyTimeRange"
                  :static-options="SystemConstants.CARGO_READY_TIME_RANGES"
                  @parentCallBack="p=>{quotation.cargoReadyTimeRange=p.value}"
                />
                <el-date-picker
                  v-if="quotation.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code"
                  v-model="quotation.cargoReadyTimeDate"
                  no="cargoReadyTimeDate"
                  type="datetime"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--20NOR数量-->
              <el-form-item :label="$t('CargoMsg.Cargo_20NORQuantity')">
                <cargo-input-number v-model="quotation.num20Nor" no="num20Nor" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--40NOR数量-->
              <el-form-item :label="$t('CargoMsg.Cargo_40NORQuantity')">
                <cargo-input-number v-model="quotation.num40Nor" no="num40Nor" :style="formNumberWidth" :disabled="!editing" :precision="0" :controls="false" :max="999999999" :min="0" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <!--服务条款-->
              <el-form-item :label="$t('CargoMsg.Cargo_Terms')">
                <cargo-advance-select
                  no="serviceTerm"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_IncoTerm"
                  callback-method-type="value"
                  :default-value="quotation.serviceTerm"
                  :callback-params="{key:'incoTerm'}"
                  @parentCallBack="p => quotation.serviceTerm = p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--直达/中转-->
              <el-form-item :label="$t('CargoMsg.Cargo_DirectOrTransshipment')">
                <cargo-advance-select
                  no="directTransit"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="quotation.directTransit"
                  :static-options="SystemConstants.DIRECT_TRANSITS"
                  @parentCallBack="p=>{quotation.directTransit=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--中转港-->
              <el-form-item
                v-if="quotation.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code"
                :label="$t('SeaExport.TransitPort')"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="quotation.transferPortCode"
                  style="width:100%"
                  @parentCallBack="p=>quotation.transferPortCode=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--航线-->
              <el-form-item :label="$t('CargoMsg.Cargo_Airline')">
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Region"
                  filterable
                  :default-value="quotation.commerceCode"
                  style="width:100%"
                  @parentCallBack="p=>{quotation.commerceCode=p.value;}"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <!--船公司-->
              <el-form-item :label="$t('SeaExport.ShippingCompany')">
                <cargo-advance-select
                  no="carrierId"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_Company"
                  :method-params="{seaCmp:true,active:true}"
                  :default-value="quotation.carrierId || ''"
                  placeholder=" "
                  @parentCallBack="p => quotation.carrierId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--货物类型-->
              <el-form-item :label="$t('SeaExport.CargoType')">
                <cargo-advance-select
                  no="cargoType"
                  filterable
                  :select-type="TYPE_NAMES.basic_data_CargoType"
                  callback-method-type="value"
                  :default-value="quotation.cargoType"
                  :callback-params="{key:'cargoType'}"
                  @parentCallBack="p => quotation.cargoType = p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--危险品等级-->
              <el-form-item
                v-if="quotation.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
                :label="$t('SeaExport.DangerousClass')"
              >
                <cargo-advance-select
                  no="dangerousGoodsLevel"
                  tag-value="code"
                  filterable
                  :clearable="false"
                  :default-value="quotation.dangerousGoodsLevel"
                  :static-options="SystemConstants.DANGEROUS_GOODS_LEVELS"
                  @parentCallBack="p=>{quotation.dangerousGoodsLevel=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--UN NO 4位整数-->
              <el-form-item
                v-if="quotation.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code"
                label="UN NO"
              >
                <el-input-number
                  v-model="quotation.unNo"
                  no="unNo"
                  :controls="false"
                  :style="formNumberWidth"
                  :precision="0"
                  :min="0"
                  :max="9999"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--长宽高-->
              <el-form-item
                v-if="quotation.cargoType === ImportConstants.CARGOTYPE_OOG.code"
                :label="$t('CargoMsg.Cargo_Dimensions')"
                class="length-weight-height"
              >
                <cargo-length-width-height
                  :form="quotation"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--温度-->
              <el-form-item
                v-if="quotation.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
                :label="$t('SeaExport.Temperature')"
              >
                <el-input-number
                  v-model="quotation.temperature"
                  no="temperature"
                  :controls="false"
                  style="width: 230px;"
                  :precision="0"
                />
                <span>℃</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--通风量-->
              <el-form-item
                v-if="quotation.cargoType === ImportConstants.CARGOTYPE_FROZEN.code"
                :label="$t('SeaExport.VentilationQuantity')"
              >
                <el-input-number
                  v-model="quotation.ventilationQuantity"
                  no="ventilationQuantity"
                  :controls="false"
                  style="width: 230px;"
                  :precision="0"
                />
                <span>%</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!--备注-->
          <el-row>
            <el-col :span="24">
              <el-input v-model="quotation.remarks" no="remarks" :placeholder="$t('Pricing.Remarks')" type="textarea" :rows="5" :disabled="!editing" />
            </el-col>
          </el-row>
        </el-form>
        <el-form v-show="!showDetail && !quotation.uuid" class="section" style="text-align: right">
          <el-row>
            <el-col :span="24">
              <el-button no="onNextStep" type="primary" @click="onNextStep">{{ $t('Pricing.Next') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <span v-if="showDetail">
          <!-- 运价信息 -->
          <div style="border-bottom: 2px solid #E3E3E3;" />
          <span class="blue" style="font-size: 14px; line-height: 25px; ">{{ $t('Pricing.PriceInfo') }}</span>
          <el-form class="section" :disabled="!canUpdate">
            <el-row v-if="editing">
              <el-col :span="24">
                <el-button no="onAddP" type="primary" @click="onAdd_P">{{ $t('Pricing.NewRate') }}</el-button>
                <el-button no="onDeleteP" type="danger" :disabled="!(this.priceSource && this.priceSource.length > 0)" @click="onDelete_P">{{ $t('Pricing.DelRate') }}</el-button>
                <el-button no="onMarkup" type="primary" :disabled="!(this.priceSource && this.priceSource.length > 0)" @click="onMarkup">{{ $t('Pricing.MarkupRate') }}</el-button>

                <span v-if="quotation.type==PriceConstant.QUOTATION_FCL">
                  <label style="padding-left: 10px;">20'</label>
                  <el-input-number no="eq20" style="padding-left: 10px;" :value="Number(qfMarkups.eq20) === 0 ? undefined : qfMarkups.eq20" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qfMarkups.eq20=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">40'</label>
                  <el-input-number no="eq40" style="padding-left: 10px;" :value="Number(qfMarkups.eq40) === 0 ? undefined : qfMarkups.eq40" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qfMarkups.eq40=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">40'HC</label>
                  <el-input-number no="eqHc" style="padding-left: 10px;" :value="Number(qfMarkups.eqHc) === 0 ? undefined : qfMarkups.eqHc" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qfMarkups.eqHc=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">45'</label>
                  <el-input-number no="eq45" style="padding-left: 10px;" :value="Number(qfMarkups.eq45) === 0 ? undefined : qfMarkups.eq45" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qfMarkups.eq45=val!==0?val:undefined}" />
                </span>
                <span v-if="quotation.type==PriceConstant.QUOTATION_LCL">
                  <label style="padding-left: 10px;">{{ $t('Pricing.WeightPrice') }}</label>
                  <el-input-number no="weightPrice" style="padding-left: 10px;" :value="Number(qlMarkups.weightPrice) === 0 ? undefined : qlMarkups.weightPrice" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qlMarkups.weightPrice=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">{{ $t('Pricing.VolumePrice') }}</label>
                  <el-input-number no="volumePrice" style="padding-left: 10px;" :value="Number(qlMarkups.volumePrice) === 0 ? undefined : qlMarkups.volumePrice" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qlMarkups.volumePrice=val!==0?val:undefined}" />
                </span>
                <span v-if="quotation.type==PriceConstant.QUOTATION_AIR">
                  <label style="padding-left: 10px;">M</label>
                  <el-input-number no="minCharge" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.minCharge) === 0 ? undefined : qaMarkups.minCharge" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.minCharge=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">N</label>
                  <el-input-number no="step" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.step) === 0 ? undefined : qaMarkups.step" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.step=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">+45</label>
                  <el-input-number no="p45" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.p45) === 0 ? undefined : qaMarkups.p45" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.p45=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">+100</label>
                  <el-input-number no="p100" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.p100) === 0 ? undefined : qaMarkups.p100" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.p100=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">+300</label>
                  <el-input-number no="p300" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.p300) === 0 ? undefined : qaMarkups.p300" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.p300=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">+500</label>
                  <el-input-number no="p500" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.p500) === 0 ? undefined : qaMarkups.p500" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.p500=val!==0?val:undefined}" />
                  <label style="padding-left: 10px;">+1000</label>
                  <el-input-number no="p1000" style="padding-left: 5px;width: 100px;" :value="Number(qaMarkups.p1000) === 0 ? undefined : qaMarkups.p1000" :precision="2" :controls="false" :max="999999999" :min="-999999999" @input="val=>{qaMarkups.p1000=val!==0?val:undefined}" />
                </span>
              </el-col>
            </el-row>
          </el-form>
          <el-form class="section" :disabled="!canUpdate">
            <el-row>
              <el-col :span="24">
                <!--整箱-->
                <cargo-ag-grid
                  v-if="quotation.type === PriceConstant.QUOTATION_FCL"
                  key="22020204"
                  config-module="22020204"
                  :grid-params.sync="fcl.gridParams"
                  :grid-options="fcl.gridOptions"
                  :column-defs="fclColumnDefs"
                  :row-data="fclRowData"
                  style="flex: 1"
                  @gridReady="params=>{fcl.gridApi=params.api}"
                />
                <!--拼箱-->
                <cargo-ag-grid
                  v-if="quotation.type === PriceConstant.QUOTATION_LCL"
                  key="22020205"
                  config-module="22020205"
                  :grid-params.sync="lcl.gridParams"
                  :grid-options="lcl.gridOptions"
                  :column-defs="lclColumnDefs"
                  :row-data="lclRowData"
                  style="flex: 1"
                  @gridReady="params=>{lcl.gridApi=params.api}"
                />
                <!--空运-->
                <cargo-ag-grid
                  v-if="quotation.type === PriceConstant.QUOTATION_AIR"
                  key="22020206"
                  config-module="22020206"
                  :grid-params.sync="air.gridParams"
                  :grid-options="air.gridOptions"
                  :column-defs="airColumnDefs"
                  :row-data="airRowData"
                  style="flex: 1"
                  @gridReady="params=>{air.gridApi=params.api}"
                />
              </el-col>
            </el-row>
          </el-form>
          <!-- 其他费用 -->
          <div style="border-bottom: 2px solid #E3E3E3;" />
          <span class="blue" style="font-size: 14px; line-height: 25px; ">{{ $t('Pricing.OtherCharge') }}</span>
          <el-form v-if="editing" :disabled="!canUpdate" :inline="true" label-width="60" label-position="left" class="section">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('Pricing.Currency')">
                  <cargo-advance-select
                    no="currency"
                    filterable
                    :clearable="false"
                    :default-value="filter.currency"
                    :select-type="selectTypeNames.basic_data_Currency"
                    @parentCallBack="currencyParentCallBack"
                  />
                </el-form-item>
                <el-button no="onAddC" type="primary" style="margin-left: 10px;" @click="onAdd_C">{{ $t('Pricing.Add') }}</el-button>
                <el-button no="onDeleteC" type="danger" :disabled="!charge.selectedRow" @click="onDelete_C">{{ $t('Pricing.Delete') }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-form class="section" :disabled="!canUpdate">
            <el-row>
              <el-col :span="24">
                <cargo-ag-grid
                  ref="chargeDetailGrid"
                  key="22020207"
                  config-module="22020207"
                  :grid-params.sync="charge.gridParams"
                  :grid-options="charge.gridOptions"
                  :column-defs="chargeColumnDefs"
                  :row-data="chargeRowData"
                  style="flex: 1"
                  @gridReady="params=>{charge.gridApi=params.api}"
                />
              </el-col>
            </el-row>
          </el-form>
          <!-- 文件历史 -->
          <span v-if="quotation && quotation.uuid">
            <div style="border-bottom: 2px solid #E3E3E3;" />
            <span class="blue" style="font-size: 14px; line-height: 25px; ">{{ $t('Pricing.FileHistory') }}</span>
            <el-form class="section" :disabled="!editing || quotation.status2 === SystemConstants.QUOTE_STATUS_QUOTED.code">
              <el-row>
                <el-col :span="24">
                  <el-button no="toFileQuery" type="primary" @click="toFileQuery">{{ $t('FileHistory.Refresh') }}</el-button>
                  <el-button v-permission="['button_FileHistory_fileUpload']" no="upload" type="primary" @click="file.cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
                  <el-button v-permission="['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']" no="fileRemove" type="danger" @click="fileRemove">{{ $t('FileHistory.Delete') }}</el-button>
                  <el-button no="fileDownload" type="primary" @click="fileDownload">{{ $t('FileHistory.BatchDownload') }}</el-button>
                  <el-button no="fileSendEmail" type="primary" @click="fileSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
                </el-col>
              </el-row>
            </el-form>
            <el-form class="section" :disabled="!editing">
              <el-row>
                <el-col :span="24">
                  <cargo-ag-grid
                    key="22020208"
                    config-module="22020208"
                    :grid-params.sync="file.gridParams"
                    :grid-options="file.gridOptions"
                    :column-defs="file.columnDefs"
                    :row-data="file.rowData"
                    style="flex: 1"
                    @gridReady="params=>{file.gridApi=params.api}"
                  />
                </el-col>
              </el-row>
            </el-form>
          </span>
        </span>
      </div>
    </el-dialog>

    <!-- 新建临时客户 -->
    <el-dialog
      class="quotationDetail"
      :visible="client.visible"
      :title="$t('Pricing.QuotationClient')"
      width="600px"
      top="5vh"
      :close-on-click-modal="false"
      @close="onCancelClient"
    >
      <div style="flex-direction:column;">
        <el-form class="section">
          <el-row v-show="editing">
            <el-col :span="24">
              <el-button no="onSaveClient" :disabled="!!(client.disableQuotationClientName && client.disableQuotationClientName === client.quotationClient.name)" type="primary" @click="onSaveClient">{{ $t('Pricing.Save') }}</el-button>
              <el-button no="onCancelClient" type="primary" @click="onCancelClient">{{ $t('Pricing.Cancel') }}</el-button>
              <el-button no="onRefreshClient" type="primary" @click="onRefreshClient">{{ $t('Pricing.Refresh') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-form label-width="70px" label-position="right" class="section">
          <el-row :gutter="5" type="flex">
            <el-col :span="12">
              <el-col>
                <el-form-item :label="$t('Pricing.ClientName')" required>
                  <!--临时客户-->
                  <cargo-advance-select
                    ref="clientName"
                    no="name"
                    :disabled="!editing"
                    :custom-label="(item)=>`${item.name}`?`[${item.branchId?branchMap.get(item.branchId):branchMap.get($store.getters.currentOfficeId)}]${item.name}`:''"
                    :show-custom-label-in-option="true"
                    filterable
                    :default-value="client.quotationClient.name || undefined"
                    :cache="false"
                    :allow-create="true"
                    tag-name="name"
                    tag-value="name"
                    :filter-tag-names="['code','name']"
                    :static-options="filter.clientList"
                    @parentCallBack="clientParentCallBack"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Contact')" required>
                  <el-input ref="clientContact" v-model="client.quotationClient.contact" no="clientContact" :maxlength="32" :disabled="!editing" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Phone')" required>
                  <el-input ref="clientPhone" v-model="client.quotationClient.phone" no="clientPhone" :maxlength="32" :disabled="!editing" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Fax')">
                  <el-input v-model="client.quotationClient.fax" no="clientFax" :maxlength="32" :disabled="!editing" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Email')">
                  <el-input v-model="client.quotationClient.email" no="clientEmail" :maxlength="64" :disabled="!editing" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Owner')">
                  <cargo-user-select
                    no="owner"
                    :method-params="{category:'role',shape:'sales'}"
                    :default-value="client.quotationClient.ownerId||''"
                    @change="p=>{client.quotationClient.ownerId=p.value||0}"
                  />
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col>
                <el-form-item :label="$t('Pricing.Address')">
                  <el-input v-model="client.quotationClient.address" no="address" :maxlength="128" type="textarea" :rows="5" :disabled="!editing" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$t('Pricing.Remarks')">
                  <el-input v-model="client.quotationClient.remarks" no="remarks" :maxlength="255" type="textarea" :rows="5" :disabled="!editing" />
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="file.cloudFile.visible"
      :job="fileCloudFileJob"
      :lob="file.cloudFile.lob"
      @uploadDone="toFileQuery"
    />

    <!-- 文件-属性详情 -->
    <el-dialog
      v-if="file.isShowingDetailForm"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible="file.isShowingDetailForm"
      :title="file.showDetailTitle"
      width="450px"
      @close="() => file.isShowingDetailForm = false"
    >
      <cargo-ag-grid
        :grid-options="this.file.gridOptionsFileDetail"
        :column-defs="this.file.columnDefsFileDetail"
        :row-data="this.file.rowDataFileDetail"
        style="width:400px;height: 300px"
        @gridReady="params=>this.file.gridApiFileDetail=params.api"
      />
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <send-email-dialog
      v-if="file.sendEmailDialog.visible"
      ref="file.sendEmailDialog"
      :visible.sync="file.sendEmailDialog.visible"
      :context="null"
      :job="fileCloudFileJob"
      source="quotationDetailDialog"
      :send-email-data="file.sendEmailDialog"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="{}"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />

    <!-- 委托单位选择 -->
    <el-dialog
      class="quotationDetail"
      :visible="customerPopup.visible"
      :title="$t('Pricing.AuthorizedClient')"
      width="400px"
      top="5vh"
      :close-on-click-modal="false"
      @close="customerPopup.visible = false"
    >
      <div style="flex-direction:column;">
        <el-form label-width="70px" label-position="right">
          <el-form-item :label="$t('Pricing.AuthorizedClient')">
            <cargo-company-select
              :method-params="{customer:true,active:true}"
              :default-value="customerPopup.customerId || undefined"
              @change="p=>{customerPopup.customerId=p.value}"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;">
          <el-button no="customerOkEventHandler" type="primary" size="mini" @click="customerOkEventHandler">{{ $t('Pricing.OK') }}</el-button>
          <el-button no="customerCancel" size="mini" @click="customerPopup.visible = false">{{ $t('Pricing.CANCEL') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 拒绝报价弹框 -->
    <el-dialog
      no="refuseQuotationDialog"
      :visible.sync="refuseQuotationDialog.visible"
      :title="$t('CargoMsg.Cargo_Tips')"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="refuseQuotationDialog.visible = false"
    >
      <el-form label-width="70px" label-position="right">
        <div style="margin-left: 230px;margin-top: 5px;margin-bottom: 5px;font-size: larger;">{{ $t('CargoMsg.Cargo_ConfirmRejectQuote') }}</div>
        <el-form-item :label="$t('Partners.RefuseRemark') + ':'">
          <el-input
            v-model="refuseQuotationDialog.refuseReason"
            no="refuseReason"
            type="textarea"
            :rows="6"
            style="width: 450px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button no="confirm" type="primary" @click="editStatus(SystemConstants.QUOTE_ACTION_REFUSE.code)">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="cancel" @click="p => {refuseQuotationDialog.refuseReason = '';refuseQuotationDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import { chargeItemCompatibleLanguage, DocumentManage, multiply } from '@/utils/commonUtil'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { PriceUtils as PriceUtil, PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { Quotation } from '@/class/model/price/Quotation'
import { QuotationFclDetail } from '@/class/model/price/QuotationFclDetail'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryQuotationClient, saveQuotationClient } from '@/api/sales/quotationClient'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { PriceAirUtil } from '@/class/cargo/model/utils/PriceAirUtil'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { deleteFile, getFileList, saveMetaData } from '@/api/storage'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAirNumericInput from '@/components/Cargo/Common/CargoAgGridAirNumericInput/index'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import URL from '@/api/urlTranslator'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'
import { isNumber, sortByMultiField } from '@/utils'
import { QuotationChargeDetail } from '@/class/model/price/QuotationChargeDetail'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getShippingSchedules } from '@/api/price/shippingSchedule'
import { Company } from '@/class/model/mdm/Company'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { QuotationAirDetail } from '@/class/model/price/QuotationAirDetail'
import { QuotationLclDetail } from '@/class/model/price/QuotationLclDetail'
import { saveQuotation, queryPriceServiceAir, editQuotationStatus } from '@/api/price/quotation'
import { queryEffectiveSurchargeFCL, queryEffectiveSurchargeFCL2 } from '@/api/price/surchargeFcl'
import { querySurchargeAirsByScore } from '@/api/price/priceAir'
import { queryEffectivePodCharge } from '@/api/price/podCharge'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { checkCompany, chineseNameIsExist } from '@/api/company'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { Job } from '@/class/model/booking/Job'
import DateUtils from '@/utils/dateUtils'
import moment from 'moment'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { loadSpecificBasicInfo } from '@/api/cache'
import { SHIPMENT_CHARGE_MEASURE } from '@/class/cargo/model/parameters/ChargeMeasure'
import * as NumberUtils from '@/utils/NumberUtils'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber.vue'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import cargoLengthWidthHeight from '@/components/Cargo/Common/cargoLengthWidthHeight'
import $store from '@/store'
import { FILE_BELONG_INQUIRY, QUOTE_ACTION_REFUSE } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'QuotationDetailDialog',
  components: { cargoLengthWidthHeight, cargoUserSelect, CargoAdvanceSelect, cargoCompanySelect, cargoCloudFileUpload, cargoTemplateSelectorDialog, sendEmailDialog, cargoInputNumber },
  props: {
    isEditAll: {
      type: Boolean,
      default: () => false
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    },
    editing: {
      type: Boolean,
      default: () => false
    },
    showQuotationDetail: {
      type: Boolean,
      required: false,
      default: () => false
    },
    filterLevel: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {
      refuseQuotationDialog: { // 拒绝原因 弹窗
        visible: false,
        refuseReason: ''
      },
      PriceConstant, SystemConstants, ColumnUtils, TYPE_NAMES, ImportConstants,
      priceTypes: PriceConstant.PRICE_TYPES,
      vesselList: [],
      voyageList: [],
      quotationType: null,
      documentManage: new DocumentManage(),
      formItemWidth: 'width: 250px;', // 表单输入控件宽度统一控制
      formNumberWidth: 'width: 246px;', // 表单输入控件宽度统一控制
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      showDetail: false,
      quotation: new Quotation().fillDefaultValue().getData(),
      isEmptyQuotation: false, // 报价分两种，一种没有价格，销售自己手填，称为空报价；一种系统已有价格，选中后加价再向客户报价。
      config: null,
      branchMap: new Map(),
      filter: {
        clientList: [],
        currency: 'USD'
      },
      officeList: [],
      seaPortList: [],
      companyList: [],
      qfMarkups: { // 整箱运价
        eq20: 0,
        eq40: 0,
        eqHc: 0,
        eq45: 0
      },
      qlMarkups: { // 拼箱运价
        weightPrice: 0,
        volumePrice: 0
      },
      qaMarkups: { // 空运运价
        minCharge: 0,
        step: 0,
        p45: 0,
        p100: 0,
        p300: 0,
        p500: 0,
        p1000: 0
      },
      charge: {
        rowData: [],
        selectedRow: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            disableLeftRightKey: true
          },
          onRowDragEnd: this.refreshSerialNumberForCharge,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          onRowClicked: this.onChargeRowClicked
        },
        gridParams: {},
        gridApi: null
      },
      file: {
        docType: [],
        fileName: '',
        fileIdList: '',
        storageURL: '',
        fileTypeMap: new Map(),
        cloudFile: {
          visible: false,
          job: new Quotation(),
          lob: ''
        },
        sendEmailDialog: {
          visible: false,
          emailTitle: '',
          emailContent: '',
          detailCode: '',
          fileIdList: '',
          fileList: []
        },
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            this.onFileTypeCellFocused(event)
          },
          treeData: true,
          getDataPath: data => {
            return (data.path || '').split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('FileHistory.fileName'),
            field: 'fileName',
            width: 240,
            headerCheckboxSelection: false,
            valueFormatterParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return false
              }
            }
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: '',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 55,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('FileHistory.fileVersion'),
            field: 'fileVersion',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.jobType'),
            field: 'fileType',
            width: 200,
            valueFormatter: params => {
              return this.fileTypeLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('FileHistory.fileType'),
            field: 'fileFormat',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.fileSize'),
            field: 'fileSize',
            width: 200,
            valueFormatter: params => {
              return this.fileSizeColumnLabel(params.value)
            }
          },
          {
            headerName: this.$t('FileHistory.createdBy'),
            field: 'createdBy',
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('FileHistory.createdDate'),
            field: 'createDate',
            width: 200
          },
          {
            headerName: this.$t('FileHistory.Details'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
              return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
            }
          },
          {
            headerName: this.$t('FileHistory.view'),
            field: 'fileId',
            width: 200,
            cellRenderer: params => {
              const methodOnFileViewPath = this.documentManage.getPath('onFileView')
              return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.view')}</a>`
            }
          }
        ],
        fileTypeEditor: {
          visible: false,
          fileId: '',
          fileCategory: ''
        },
        gridApiFileDetail: null,
        gridOptionsFileDetail: {
          context: {
            componentParent: this
          }
        },
        columnDefsFileDetail: [
          {
            headerName: this.$t('FileHistory.tagName'),
            field: 'key',
            width: 150
          },
          {
            headerName: this.$t('FileHistory.tagValue'),
            field: 'val',
            width: 200
          }
        ],
        rowDataFileDetail: [],
        isShowingDetailForm: false,
        showDetailTitle: ''
      },
      fcl: {
        rowData: [],
        selectedRow: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          defaultColDef: {
            disableLeftRightKey: true
          },
          onRowClicked: this.onFclRowClicked
        },
        gridParams: {},
        gridApi: null
      },
      lcl: {
        rowData: [],
        selectedRow: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridAirNumericInput,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          defaultColDef: {
            disableLeftRightKey: true
          },
          onRowClicked: this.onLclRowClicked
        },
        gridParams: {},
        gridApi: null
      },
      air: {
        rowData: [],
        selectedRow: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridAirNumericInput,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridDateTimeEditor
          },
          defaultColDef: {
            disableLeftRightKey: true
          },
          onRowClicked: this.onAirRowClicked
        },
        gridParams: {},
        gridApi: null
      },
      client: {
        visible: false,
        quotationClient: new QuotationClient().fillDefaultValue().getData(),
        disableQuotationClientName: '' // 不可用的客户名称
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new Quotation(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      quotationDetail: null, // 当前选中的运价数据，无则取第一条
      airServiceItems: [], // 空运服务项目
      customerPopup: { // 新建委托，选择委托单位
        visible: false,
        customerId: 0
      },
      eqs: ['20', '40', 'hc', '45'],
      typeMap: { 'L': 0, 'D': 1, 'S': 2 },
      chargeItemSet: new Set(),
      UNIT_MAP: {	'20': ChargeMeasure.C20_CHARGE_MEASURE.code, '40': ChargeMeasure.C40_CHARGE_MEASURE.code, 'hc': ChargeMeasure.C40H_CHARGE_MEASURE.code, '45': ChargeMeasure.C45_CHARGE_MEASURE.code }
    }
  },
  computed: {
    associatedInquiry() {
      return !!this.quotation.inquiryPriceUuid
    },
    // 负责人才能审批、编辑
    canUpdate() {
      return !this.associatedInquiry || this.isEditAll || this.quotation.solveUserId === $store.getters.userId + '' || this.$store.getters.isAdmin
    },
    fileCloudFileJob() { // 文件操作使用
      return new Quotation(this.quotation)
    },
    priceSource() {
      if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
        return this.fcl.rowData || []
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) {
        return this.lcl.rowData || []
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
        return this.air.rowData || []
      }
      return []
    },
    chargeRowData() {
      return this.charge.rowData.filter(p => !p.deleted)
    },
    chargeColumnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          initialWidth: 130,
          checkboxSelection: true,
          rowDrag: this.editing,
          colId: 'serialNumber',
          field: 'serialNumber',
          sortable: true,
          suppressMenu: true,
          suppressSizeToFit: true,
          headerCheckboxSelection: true,
          lockVisible: true,
          initialHide: false
        },
        {
          headerName: this.$t('Pricing.ChargeType'),
          field: 'type',
          colId: 'type',
          valueFormatter: (params) => {
            return ColumnUtils.chargeTypeLabelFunc(params.value, params.data)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: PriceConstant.PRICE_CHARGE_TYPE,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onChargeCellChange(p),
          width: 200
        },
        {
          headerName: this.$t('Pricing.ChargeName'),
          colId: 'chargeId',
          field: 'chargeId',
          width: 200,
          valueFormatter: (params) => {
            const obj = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', params.value)
            if (!obj) return ''
            if (obj.scaleCode) {
              return '[' + obj.scaleCode + ']' + (this.$store.getters.language === 'zh' ? obj.zhName : obj.enName)
            }
            return this.$store.getters.language === 'zh' ? obj.zhName : obj.enName
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              methodParams: {},
              tagValue: 'itemId',
              tagName: this.$store.getters.language === 'zh' ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global'
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Currency'),
          colId: 'currency',
          field: 'currency',
          width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              methodParams: {},
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              clearable: false
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Rate'),
          colId: 'rate',
          field: 'rate',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        {
          headerName: this.$t('Pricing.ChargeUnit'), colId: 'unit', field: 'unit', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: 'chineseName',
              methodParams: this.getChargeUnitFilter(),
              filterable: true,
              clearable: false
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Num'), colId: 'num', field: 'num', width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Sum'),
          field: 'amount',
          colId: 'amount',
          valueFormatter: (params) => {
            return PriceUtils.numberWithNILColumnLabelFunc(params.data, 'amount')
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.RateByCost'),
          colId: 'costRate',
          field: 'costRate',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onChargeCellChange(p)
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onChargeCellChange(p) }
      ]
    },
    fclRowData() {
      return this.fcl.rowData.filter(p => !p.deleted)
    },
    fclColumnDefs() {
      return [
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.Source'),
          field: 'source',
          colId: 'source',
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { bookingAgent: true, active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Direct'),
          field: 'direct',
          colId: 'direct',
          valueFormatter: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, PriceConstant.PRICE_DIRECT)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: PriceConstant.PRICE_DIRECT,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          width: 200,
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { active: true, seaCmp: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor' },
        { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode',
          valueFormatter: (params) => {
            if (!params.value || params.value === 'NotRequired') {
              return ''
            }
            return params.value
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: PriceConstant.PRICE_SERVICE_MODES,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          width: 200,
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              filterTagNames: ['code'],
              clearable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_EQType,
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              filterTagNames: ['code'],
              clearable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 20\'', field: 'eq20', colId: 'eq20', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 40\'', field: 'eq40', colId: 'eq40', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 40\'HC', field: 'eqHc', colId: 'eqHc', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 45\'', field: 'eq45', colId: 'eq45', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 20\'NOR', field: 'eq20nor', colId: 'eq20nor', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'All In 40\'NOR', field: 'eq40nor', colId: 'eq40nor', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncShowZero(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Sum'), field: 'amount', colId: 'amount', width: 200,
          valueFormatter: (params) => {
            if (!params.value || isNaN(params.value) || Number(params.value) === 0) return 0
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          }
        },
        { headerName: this.$t('Pricing.Cost20'), field: 'cost20', colId: 'cost20', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Cost40'), field: 'cost40', colId: 'cost40', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.CostHC'), field: 'costHc', colId: 'costHc', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Cost45'), field: 'cost45', colId: 'cost45', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: '20\' NOR', field: 'cost20nor', colId: 'cost20nor', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: '40\' NOR', field: 'cost40nor', colId: 'cost40nor', width: 200, hide: this.editing,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.FreeTime'), field: 'freeTime', colId: 'freeTime', width: 200,
          editable: this.associatedInquiry,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0,
              min: 0,
              max: 999999999
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.VAT'), field: 'vat', colId: 'vat', width: 200,
          valueFormatter: (params) => {
            if (!params.value || isNaN(params.value) || Number(params.value) === 0) return 0
            return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              max: 10,
              min: 1
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: PriceConstant.PRICE_PAYMENT_TERM,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 13
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 13
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 16
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: PriceConstant.CABIN_NATURE,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onFclCellChange(p) },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.priceTypes, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: PriceConstant.PRICE_TYPES,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'englishName',
              tagName: 'englishName',
              allowCreate: true,
              staticOptions: this.vesselList,
              filterable: true
            }
          }),
          onCellValueChanged: (params) => {
            this.onFclCellChange(params)
          }
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const vesselId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', params.data.vessel, 'vesselId')
            const voyages = this.voyageList.filter(item => item.vesselId === vesselId)
            return {
              selectProps: {
                cache: false,
                staticOptions: voyages,
                filterable: true,
                tagName: 'voyageNo',
                allowCreate: true,
                tagValue: 'voyageNo'
              }
            }
          },
          onCellValueChanged: (params) => {
            this.onFclCellChange(params)
          }
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        },
        { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onFclCellChange(p)
        }
      ]
    },
    lclRowData() {
      return this.lcl.rowData.filter(p => !p.deleted)
    },
    lclColumnDefs() {
      return [
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          valueFormatter: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Source'),
          field: 'source',
          colId: 'source',
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { bookingAgent: true, active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              filterTagNames: ['code'],
              clearable: false
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.WeightPrice'), field: 'weightPrice', colId: 'weightPrice', width: 200,
          valueFormatter: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.VolumePrice'), field: 'volumePrice', colId: 'volumePrice', width: 200,
          valueFormatter: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.WeightCost'), field: 'weightCost', colId: 'weightCost', width: 200,
          valueFormatter: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          },
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.VolumeCost'), field: 'volumeCost', colId: 'volumeCost', width: 200,
          valueFormatter: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          },
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: PriceConstant.PRICE_PAYMENT_TERM,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          tooltip: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              multiple: true,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { active: true, seaCmp: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p) },
        { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 13
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p) },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 13
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p) },
        { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 16
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p) },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onLclCellChange(p) }
      ]
    },
    airRowData() {
      return this.air.rowData.filter(p => !p.deleted)
    },
    airColumnDefs() {
      return [
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.Source'),
          field: 'source',
          colId: 'source',
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              methodParams: { bookingAgent: true, active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onLclCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          tooltip: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        {
          headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 200,
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true, airCmp: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        { headerName: this.$t('Pricing.Flight'), field: 'flight', colId: 'flight', width: 200,
          valueFormatter: (params) => {
            return PriceAirUtil.serviceItemLabelFunction(params.data, params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.airServiceItems,
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        {
          headerName: this.$t('Pricing.Aircraft'), field: 'aircraft', colId: 'aircraft', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.aircraftLabelFunction(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              tagValue: 'code',
              tagName: 'code',
              filterable: true,
              filterTagNames: ['code'],
              clearable: false
            }
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        {
          headerName: 'M', field: 'minCharge', colId: 'minCharge', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'minCharge')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: true,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        {
          headerName: 'N', field: 'step', colId: 'step', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'step')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: true
          },
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        { headerName: '+45', field: 'p45', colId: 'p45', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'p45')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: true,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: '+100', field: 'p100', colId: 'p100', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'p100')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: true,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: '+300', field: 'p300', colId: 'p300', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'p300')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: true,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: '+500', field: 'p500', colId: 'p500', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'p500')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: false,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: '+1000', field: 'p1000', colId: 'p1000', width: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'p1000')
          },
          minWidth: 220,
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: false,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: 'FSC', field: 'fsc', colId: 'fsc', width: 220,
          minWidth: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'fsc')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: false,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: 'SSC', field: 'ssc', colId: 'ssc', width: 220,
          minWidth: 220,
          valueFormatter: (params) => {
            return PriceUtils.numberColumnLabelFuncQuotation_TACT(params.data, 'ssc')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridAirNumericInput',
          cellEditorParams: {
            showTact: false,
            precision: 2
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        {
          headerName: this.$t('Pricing.Agent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          },
          width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { bookingAgent: true, active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onAirCellChange(p)
        },
        { headerName: this.$t('Pricing.DepartureDayOfAir'), field: 'frequency8', colId: 'frequency8', width: 200,
          valueFormatter: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          editable: this.editing,
          cellEditorParams: {
            inputProps: {
              maxlength: 16
            }
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.editing,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.onAirCellChange(p) },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          editable: this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onAirCellChange(p) }
      ]
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.onShow()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
    this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    this.voyageList = await loadSpecificBasicInfo('Voyage').then(res => res.data)
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // ========================公共信息处理=====================================
    // 初始化基础信息
    async init() {
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.innerVisible = this.visible
      this.showDetail = this.showQuotationDetail
      this.quotationType = this.quotation.type
      // this.seaPortList = getCacheListByKey(basicCacheKeys.basic_data_Seaport)
      // this.companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
      const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      this.initChargeItemSet()
      // 处理临时客户 下拉框数据源
      this.branchMap = new Map()
      if (officeList && officeList.length > 0) {
        for (const item of officeList) {
          if (!item.code || this.branchMap.has(item.officeId)) continue
          this.branchMap.set(item.officeId, item.code)
        }
      }
      const conMap = { clientId: null }
      await queryQuotationClient({ condition: conMap }).then(res => {
        const clientRes = res.data
        if (clientRes && clientRes.length > 0) {
          this.filter.clientList = clientRes.filter(p => p.branchId === 1 || p.branchId === this.$store.getters.currentOfficeId)
        }
      })
      if (this.quotationType === PriceConstant.QUOTATION_AIR) {
        await queryPriceServiceAir({}).then(res => {
          this.airServiceItems = res.data.list || []
        })
      }
      // 文件信息处理
      if (this.quotation.uuid) {
        await getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.file.cloudFile.lob }).then(res => {
          res.data.forEach(item => {
            if (item.type === 2) {
              this.file.fileTypeMap.set(item.code.toUpperCase(), item.chineseName)
              this.file.docType.push(item)
            }
          })
        })
        this.toFileQuery()
      }
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },
    // 进页面显示
    onShow() {
      this.$nextTick(async() => {
        this.loading = getLoading()
	        this.quotation = this.model
        await this.init()
        this.initQuotationInfo()
        // 注意： initShipperInfo 方法要在 initQuotationInfo 之后
        await this.initShipperInfo()
        this.loading.close()
      })
    },
    // 初始化页面显示信息【运价，费用】
    initQuotationInfo() {
      // 处理运价信息
      if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
        this.readConfigFcl()
        this.fcl.rowData = this.quotation.quotationFclDetail || []
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) {
        this.readConfigLcl()
        this.lcl.rowData = (this.quotation.quotationLclDetail && this.quotation.quotationLclDetail.length > 0) ? this.quotation.quotationLclDetail.map(item => {
          const { carrier } = item
          const arr = (carrier && typeof carrier === 'string') ? carrier.split(',').filter(item => item).map(item => Number(item)) : carrier
          item.carrier = arr
          return item
        }) : []
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
        this.readConfigAir()
        this.air.rowData = this.quotation.quotationAirDetail || []
      }
      // 处理币种
      const cfgName = this.getCfgName()
      const config = LocalStorageUtils.getConfiguration(cfgName)
      if (config) {
        if (config['currency_C']) this.filter.currency = config['currency_C']
      }
      // 处理费用信息
      const chargeRowData = this.quotation.quotationChargeDetail || []
      // CARGO-39730 报价管理-其他费用-成本费率未存入数据库CARGO-40188 当费率有值，成本费率为空时，前端显示错误
      // if (chargeRowData && chargeRowData.length > 0) {
      //   for (const charge of chargeRowData) {
      //     if (!charge.costRate || charge.costRate <= 0) {
      //       charge.costRate = charge.rate
      //     }
      //   }
      // }
      this.charge.rowData = sortByMultiField(chargeRowData, ['serialNumber'], false)
    },
    // 初始化船期信息
    async initShipperInfo() {
      this.isEmptyQuotation = !this.priceSource || this.priceSource.length === 0
      if (!this.isEmptyQuotation) {
        if (!this.quotation.uuid) {
          this.quotation.pol = this.priceSource[0].pol
          this.quotation.pod = this.priceSource[0].pod
          this.syncCommerceCode()
        }
        if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
          const len = this.priceSource.length
          let qf // QuotationFCLDetail
          let proxy = {}
          const proxies = []
          for (let i = 0; i < len; i++) {
            qf = this.priceSource[i]
            proxy = {}
            proxy.pol = qf.pol
            proxy.pod = qf.pod
            proxy.carrier = qf.carrier
            proxy.lane = qf.lane
            proxy.beginDate = qf.beginDate
            proxy.endDate = qf.endDate
            proxy.index = 'index' + i
            proxies.push(proxy)
          }
          if (proxies.length > 0) {
            await getShippingSchedules({ requests: proxies }).then(res => {
              this.onSchedulesLoaded(res.data)
            }).finally(() => {
              this.loading.close()
            })
          }
        }
      }
    },
    // 船期加载完成
    onSchedulesLoaded(map) {
      const len = this.priceSource.length
      for (let i = 0; i < len; i++) {
        if (map.hasOwnProperty('index' + i)) {
          const schedule = map['index' + i]
          const qf = new QuotationFclDetail(this.priceSource[i])
          qf.closingDay = schedule.closingDay
          qf.departureDay = schedule.departureDay
          if (qf.days.indexOf('+') === qf.days.length - 1) {
            try {
              const addonDays = parseInt(qf.days.substr(0, qf.days.length - 1))
              const days = parseInt(schedule.days)
              qf.days = String(addonDays + days) + '+'
            } catch (e) {
              qf.days = '-'
            }
          } else {
            qf.days = String(schedule.days)
          }
        }
      }
    },
    // 保存
    async onSave(tipSuccess = true) {
      if (this.associatedInquiry && this.quotation.status2 === SystemConstants.QUOTE_STATUS_QUOTED.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_QuoteStatusNotAllowedSave'))
        return
      }
      if (!this.checkBasicInfo()) return
      const quotation = this.quotation
      quotation.branchId = this.$store.getters.currentOffice.officeId
      quotation.receiptRemark = ''
      quotation.deliveryRemark = ''
      // 运价费用
      const charges = []
      const chargeNumbers = []
      for (const charge of this.charge.rowData) {
        if (charge.updated || charge.deleted || !charge.uuid) {
          charges.push(charge)
        } else {
          chargeNumbers.push(charge)
        }
      }
      quotation.quotationChargeDetail = charges
      quotation.quotationChargeNumbers = chargeNumbers

      if (this.priceSource && this.priceSource.length > 0) {
        let flag = false // 是否有运价的有效期和报价单不同，并且是否需要同步报价单的有效期
        for (const price of this.priceSource) {
          if (!price.endDate || !this.quotation.endDate) continue
          if (DateUtils.formatStandardDate(price.endDate) !== DateUtils.formatStandardDate(this.quotation.endDate)) {
            flag = await this.$confirm(this.$t('Pricing.UpdateQuotationValidity'), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('common.btn.yes'),
              cancelButtonText: this.$t('common.btn.no'),
              closeOnClickModal: false,
              type: 'info'
            }).then(() => true).catch(() => false)
            break
          }
        }
        if (flag) {
          // 这里倒序排，选出有效期最晚的，然后赋值给报价单
          const priceSourceBySort = sortByMultiField(this.priceSource, ['endDate'], true)
          quotation.endDate = (priceSourceBySort && priceSourceBySort.length > 0) ? priceSourceBySort[0].endDate : this.quotation.endDate
        }
      }

      if (this.quotation.type === PriceConstant.QUOTATION_FCL) { // 整箱
        this.saveConfigFcl()
        if (!this.checkPricesFcl()) return
        quotation.quotationFclDetail = this.fcl.rowData // 整箱运价信息
        if (quotation.quotationChargeDetail && quotation.quotationChargeDetail.length > 0) {
          for (const charge of quotation.quotationChargeDetail) {
            if (!charge.unit) continue
            switch (charge.unit) {
              case ChargeMeasure.C20_CHARGE_MEASURE.code:
                if (charge.num === 0) charge.num = quotation.num20
                break
              case ChargeMeasure.C40_CHARGE_MEASURE.code:
                if (charge.num === 0) charge.num = quotation.num40
                break
              case ChargeMeasure.C40H_CHARGE_MEASURE.code:
                if (charge.num === 0) charge.num = quotation.numHc
                break
              case ChargeMeasure.C45_CHARGE_MEASURE.code:
                if (charge.num === 0) charge.num = quotation.num45
                break
              case ChargeMeasure.WGTX_CHARGE_MEASURE.code:
                if (charge.num === 0) charge.num = quotation.chargeWeight || 0
                break
            }
            charge.amount = charge.num * charge.rate
          }
        }
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) { // 空运
        this.saveConfigAir()
        if (!this.checkPricesAir()) return
        quotation.quotationAirDetail = this.air.rowData // 空运运价信息
        if (quotation.quotationAirDetail && quotation.quotationAirDetail.length > 0) {
          for (const airPrice of quotation.quotationAirDetail) {
            for (let i = 1; i < 8; i++) {
              airPrice['frequency' + i] = !!airPrice['frequency' + i]
            }
          }
        }
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) { // 拼箱
        this.saveConfigLcl()
        if (!this.checkPricesLcl()) return
        quotation.quotationLclDetail = this.lcl.rowData.map(item => {
          const carrier = item.carrier.join(',')
          return {
            ...item,
            carrier
          }
        }) // 拼箱运价信息
      }
      if (!this.checkCharges()) return
      if ((!this.priceSource || this.priceSource.length === 0) && (!quotation.quotationChargeDetail || quotation.quotationChargeDetail.length === 0)) {
        this.$message.warning(this.$t('Pricing.NoChargeAndPrice'))
        return
      }
      this.$logger.log('quotation=========保存之前', quotation)
      this.loading = getLoading()
      await saveQuotation(quotation).then((res) => {
        const quotation = res.data
        if (quotation) {
          Object.assign(this.quotation, quotation)
          this.loadQuotationRelated()
          if (tipSuccess) {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          }
          this.$emit('saveSuccess', quotation)
        }
      }).finally(() => {
        this.loading.close()
      })
      return true
    },
    // 加载详情
    async loadQuotationRelated() {
      const jobModel = new Quotation(this.quotation)
      // 清空这三个变量，否则下面的loadQuotationRelated不会加载根据参数加载对应的数据
      jobModel.quotationFclDetail = ''
      jobModel.quotationLclDetail = ''
      jobModel.quotationAirDetail = ''
      jobModel.quotationChargeDetail = ''
      await jobModel.loadQuotationRelated({
        quotation: true,
        quotationFclDetail: this.quotationType === PriceConstant.QUOTATION_FCL,
        quotationLclDetail: this.quotationType === PriceConstant.QUOTATION_LCL,
        quotationAirDetail: this.quotationType === PriceConstant.QUOTATION_AIR,
        quotationChargeDetail: true
      })
      this.initQuotationInfo()
    },
    // 取消
    onCancel() {
      // 将Flex代码屏蔽,取消时没必要做下面操作,下面操作放在进页面时加载
      // if(this.quotation.type==PriceConstant.QUOTATION_FCL)
      // {
      //   qfMarkup.readConfig();
      // }
      // else if(this.quotation.type==PriceConstant.QUOTATION_AIR)
      // {
      //   qaMarkup.readConfig();
      // }
      // else
      // {
      //   qlMarkup.readConfig();
      // }
      // _deleteCharges = null;
      // this.this.quotation.reload();
      // vbBasicInfo.updateData();
      this.handleClose()
    },
    // 打印
    onPrint() {
      if (!this.quotation.uuid) {
        this.$message.warning(this.$t('Pricing.SaveQuotation'))
        return
      }
      let type = null
      switch (this.quotation.type) {
        case PriceConstant.QUOTATION_FCL:
          type = 'PRICEFCL'
          break
        case PriceConstant.QUOTATION_AIR:
          type = 'PRICEAIR'
          break
        case PriceConstant.QUOTATION_LCL:
          type = 'PRICELCL'
          break
        default:
          type = 'PRICEFCL'
          break
      }
      if (type) {
        const params = {}
        params.QUOTATION_UUID = this.quotation.uuid
        params.classNameType = SystemConstants.PRICE
        this.templateSelectorDialog.ctx = new Quotation(this.quotation)
        this.templateSelectorDialog.category = type
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.visible = true
        // 以下屏蔽的是flex代码
        // TemplateSelectorWin.getInstance().showThisWin(this.quotation, type, params, this)
        // this.visible = false
        // TemplateSelectorWin.getInstance().addEventListener('cancelPrint', showMe)
        // FlexGlobals.topLevelApplication.previewLayer.addEventListener('backToMain', showMe)
      }
    },
    // 新建委托
    onRemoteBooking() {
      if (this.quotation.type === PriceConstant.QUOTATION_FCL && this.quotation.num20 === 0 && this.quotation.num40 === 0 && this.quotation.numHc === 0 && this.quotation.num45 === 0) {
        this.$message.warning('请录入委托箱量!')
        return
      }
      this.quotationDetail = this.getQuotationDetail()
      if (!this.quotationDetail) {
        if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
          this.$message.warning(this.$t('Pricing.PlsSelectAirOF'))
        } else {
          this.$message.warning(this.$t('Pricing.PlsSelectOF'))
        }
        return
      }
      this.customerPopup.customerId = 0
      this.customerPopup.visible = true
    },
    // 确认选择的委托单位
    customerOkEventHandler() {
      if (!this.customerPopup.customerId || parseInt(this.customerPopup.customerId) <= 0) {
        this.$message.warning(this.$t('Pricing.ClientIsEmpty'))
        return
      }
      const validateCustomerSales = parseInt(this.config.get('BookingValidateCustomerSales')) === 1
      if (this.$store.getters.isAdmin || !validateCustomerSales) {
        this.doRemoteBooking(this.customerPopup.customerId)
      } else {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', parseInt(this.customerPopup.customerId))
        if (!company || !company.uuid) return
        checkCompany({ sales: this.$store.getters.userId, companyUuid: company.uuid }).then(res => {
          if (!res.data) {
            this.$message.warning(this.$t('Price.TheBelongToYourSelect'))
            return
          }
          this.doRemoteBooking(this.customerPopup.customerId)
        })
      }
    },
    // 委托实现
    async doRemoteBooking(customerId) {
      const job = new Job().fillDefaultValue().getData()
      if (this.quotation.type !== PriceConstant.QUOTATION_FCL) {
        job.customerId = customerId
      }
      if (await BookingUtil.convertQuotationToJob(job, this.quotation, this.quotationDetail)) {
        // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
        if (job.charges && job.charges.length > 0) {
          for (const charge of job.charges) {
            if (charge.taxRate && charge.taxRate > 0) {
              continue
            }
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
            charge.taxRate = chargeItem ? (chargeItem.taxRate || 0) : 0
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.unitRate, charge.quantity), charge.taxRate)
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.unitRate, charge.quantity), charge.taxRate)
            }
            // CARGO-31003 在新增费用时，直接对特定的费用进行受控
            charge.controlled = chargeItem?.controlled
            charge.needInvoice = chargeItem?.needInvoice
          }
        }
        job.customerId = customerId
        job.quotationNo = this.quotation.quotationNo
        job.priceSource = PriceConstant.PRICE_SOURCE_QUOTATION
        job.userDefinedField1 = this.quotation.pricingUserDefinedField1
        job.userDefinedField2 = this.quotation.pricingUserDefinedField2
        job.userDefinedField3 = this.quotation.pricingUserDefinedField3
        job.userDefinedField4 = this.quotation.pricingUserDefinedField4
        this.$router.push({
          name: 'RemoteBooking',
          params: {
            view: 'detail',
            action: 'add',
            job
          }
        })
        this.innerVisible = false
      }
    },
    // 获取运价信息作为海运费
    getQuotationDetail() {
      if (this.quotation.type === PriceConstant.QUOTATION_FCL && this.fclRowData && this.fclRowData.length > 0) {
        return this.fcl.selectedRow || this.fclRowData[0]
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL && this.lclRowData && this.lclRowData.length > 0) {
        return this.lcl.selectedRow || this.lclRowData[0]
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR && this.airRowData && this.airRowData.length > 0) {
        return this.air.selectedRow || this.airRowData[0]
      }
      return null
    },
    // 下一步
    async onNextStep() {
      if (!this.checkBasicInfo()) return
      if (this.priceSource && this.priceSource.length > 0) {
        if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
          await this.queryFclQuotationCharge()
        } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) {
          await this.queryLclQuotationCharge()
        } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
          const payload = {
            bookingAgent: this.quotation.bookingAgent,
            carrier: this.quotation.carrier,
            pol: this.quotation.pol,
            pod: this.quotation.pod,
            region: this.quotation.region,
            beginDate: this.quotation.beginDate,
            endDate: this.quotation.endDate
          }
          this.fullscreenLoading = getLoading()
          await querySurchargeAirsByScore(payload).then((res) => {
            if (res.ok && res.data) {
              this.onSurchargeAirLoaded(res.data)
            }
          }).finally(() => {
            this.fullscreenLoading.close()
          })
        }
      }
      this.showDetail = true
    },
    // 查询整箱附加费
    async queryFclQuotationCharge() {
      let qf
      if (this.priceSource && this.priceSource.length === 1) {
        qf = new QuotationFclDetail(this.priceSource[0]).fillDefaultValue().getData()
        const res = await queryEffectiveSurchargeFCL(this.getSurchargeQueryProxy2(qf))
        this.onSurchargeLoaded(res.data)
      } else {
        const paramMap = {}
        let key
        for (qf of this.priceSource) {
          qf = new QuotationFclDetail(qf).fillDefaultValue().getData()
          const priceFcl = qf.priceFcl || {}
          key = [qf.carrier, priceFcl.bookingAgent,
            qf.eqType,
            priceFcl.beginDate.time,
            priceFcl.endDate.time].join('_')
          if (!paramMap.hasOwnProperty(key)) {
            paramMap[key] = this.getSurchargeQueryProxy(qf)
          }
        }
        const res = await queryEffectiveSurchargeFCL2(paramMap)
        this.onSurchargeLoaded2(res.data)
      }
      for (qf of this.priceSource) {
        this.updateFclAmount(qf)
      }
    },
    onSurchargeLoaded(source) {
      if (!source) return
      source = this.getUnconflictSurcharges(source)

      const charges = []
      let charge
      let chargeItem
      const allIns = { '20': 0, '40': 0, 'hc': 0, '45': 0 }
      const allInsCost = { '20': 0, '40': 0, 'hc': 0, '45': 0 }
      const remarkMap = { '20': '', '40': '', 'hc': '', '45': '' }
      let eqKey
      let rate, exchange

      const qf = new QuotationFclDetail(this.priceSource[0])
      const messages = []
      const messageMap = {}
      const messageRates = []
      const messageRateMap = {}
      for (const sf of source) {
        if (sf.casePrice !== PriceConstant.NIL) { // 安票收费
          charge = new QuotationChargeDetail().fillDefaultValue().getData()
          chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', sf.chargeScaleCode)
          if (chargeItem) {
            charge.chargeId = chargeItem.itemId
            charge.chargeName = chargeItem.scaleCode
            charge.type = parseInt(this.typeMap[sf.chargeType])
            charge.currency = sf.currency
            charge.rate = charge.costRate = qf.level === 0 ? sf.costCasePrice : sf.casePrice
            charge.unit = sf.unit
            charge.num = 1
            charge.amount = charge.num * charge.rate
            charge.remarks = sf.remarks
            charges.push(charge)
          } else {
            if (!messageMap.hasOwnProperty(sf.chargeScaleCode)) {
              messages.push(sf.chargeScaleCode)
              messageMap[sf.chargeScaleCode] = 1
            }
          }
        } else {
          if (sf.chargeType === 'S') { // 附加费
            for (eqKey in this.eqs) {
              const eq = this.eqs[eqKey]
              rate = Number(qf.level === 0 ? sf['cost' + eq] : sf['sum' + eq])
              if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
              exchange = sf.currency === 'USD' ? 1 : PriceUtil.getForeignExchangeRate(sf.currency, 'USD')
              if (exchange > 0) {
                remarkMap[eq] = remarkMap[eq] + (sf.chargeScaleCode + ':' + rate + sf.currency + ',')
                allIns[eq] = allIns[eq] + rate / exchange
                allInsCost[eq] = allInsCost[eq] + rate / exchange
              } else {
                if (!messageRateMap.hasOwnProperty(sf.currency)) {
                  messageRates.push(sf.currency)
                  messageRateMap[sf.currency] = 1
                }
              }
            }
          } else if (sf.chargeType === 'L' || sf.chargeType === 'D') { // 本地或目的地费用
            for (eqKey in this.eqs) {
              const eq = this.eqs[eqKey]
              charge = new QuotationChargeDetail().fillDefaultValue().getData()
              chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', sf.chargeScaleCode)
              if (chargeItem) {
                rate = Number(qf.level === 0 ? sf['cost' + eq] : sf['sum' + eq])
                if (rate === PriceConstant.NIL || isNaN(rate) || rate === 0) { continue }
                charge.chargeId = chargeItem.itemId
                charge.chargeName = chargeItem.scaleCode
                charge.type = parseInt(this.typeMap[sf.chargeType])
                charge.currency = sf.currency
                charge.rate = charge.costRate = rate
                charge.unit = this.UNIT_MAP[eq] || sf.unit
                charge.num = this.quotation['num' + eq]
                if (!charge.num) {
                  charge.num = 0
                }
                charge.amount = charge.num * charge.rate
                charge.remarks = sf.remarks
                charges.push(charge)
              } else {
                if (!messageMap.hasOwnProperty(sf.chargeScaleCode)) {
                  messages.push(sf.chargeScaleCode)
                  messageMap[sf.chargeScaleCode] = 1
                }
              }
            }
          }
        }
      }
      this.charge.rowData = charges
      let remarks = ''
      let eqRemark = remarkMap[eqKey]
      for (eqKey in this.eqs) { // 计入AllIn
        const eq = this.eqs[eqKey]
        if (!qf['eq' + eq]) { continue }
        rate = Number(qf['eq' + eq])
        if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
        qf['eq' + eq] = Math.ceil(rate + allIns[eq])
        rate = Number(qf['cost' + eq])
        if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
        qf['cost' + eq] = Math.ceil(rate + allInsCost[eq])
        if (remarkMap[eq]) {
          eqRemark = remarkMap[eq]
          remarks += (eq === 'hc' ? "40'HC " : eq + "'") + this.$t('Pricing.ALLINIncludes') + eqRemark.substr(0, eqRemark.length - 1) + ';<br>'
        }
      }

      let msg = ''
      if (messageRates.length > 0) {
        msg += this.$t('Pricing.NoExchangeRate', [messageRates.join()]) + '<br>'
      }
      if (messages.length > 0) {
        msg += this.$t('Pricing.NoSurcharge', [messages.join()])
      }
      if (msg) {
        this.$confirm(msg, this.$t('common.tips.prompt'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'warning'
        })
      }
      this.updateFclAmount(qf)
      this.quotation.remarks = remarks.substr(0, remarks.length - 1)
    },
    onSurchargeLoaded2(rs) {
      if (!rs) return
      let key
      let source
      let eqKey
      let rate, exchange
      const messages = []
      const messageMap = {}
      for (const fclDetail of this.priceSource) {
        const qf = new QuotationFclDetail(fclDetail)
        const priceFcl = qf.priceFcl
        key = [qf.carrier, priceFcl.bookingAgent,
          qf.eqType,
          priceFcl.beginDate.time,
          priceFcl.endDate.time].join('_')
        if (rs.hasOwnProperty(key)) {
          source = Array.from(rs[key])
          if (!source || source.length === 0) { continue }
          source = this.getUnconflictSurcharges(source)

          const allIns = { '20': 0, '40': 0, 'hc': 0, '45': 0 }
          for (const sf of source) {
            if (sf.casePrice === PriceConstant.NIL) { // 安票收费
              if (sf.chargeType === 'S') { // 附加费
                for (eqKey in this.eqs) {
                  const eq = this.eqs[eqKey]
                  rate = Number(sf['sum' + eq])
                  if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
                  exchange = sf.currency === 'USD' ? 1 : PriceUtil.getForeignExchangeRate(sf.currency, 'USD')
                  if (exchange > 0) {
                    allIns[eq] = allIns[eq] + rate / exchange
                  } else {
                    if (!messageMap.hasOwnProperty(sf.currency)) {
                      messages.push(sf.currency)
                      messageMap[sf.currency] = 1
                    }
                  }
                }
              }
            }
          }
          for (eqKey in this.eqs) { // 计入AllIn
            const eq = this.eqs[eqKey]
            if (!qf['eq' + eq]) { continue }
            rate = Number(qf['eq' + eq])
            if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
            qf['eq' + eq] = Math.ceil(rate + allIns[eq])
            rate = Number(qf['cost' + eq])
            if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
            qf['cost' + eq] = Math.ceil(rate + allIns[eq])
          }
        }
        this.updateFclAmount(qf)
      }
      if (messages.length > 0) {
        this.$message.warning(this.$t('Pricing.NoExchangeRate', [messages.join()]))
      }
    },
    /**
     * 空运附加费加载
     * @param source
     */
    onSurchargeAirLoaded(source) {
      if (!source) return
      source = this.getUnconflictSurcharges(source)
      const charges = []
      let charge
      let chargeItem
      for (const sf of source) {
        charge = new QuotationChargeDetail().fillDefaultValue().getData()
        chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', sf.chargeScaleCode)
        if (chargeItem) {
          charge.chargeId = chargeItem.itemId
          charge.chargeName = chargeItem.scaleCode
          charge.type = parseInt(this.typeMap[sf.chargeType])
          charge.currency = sf.currency
          charge.unit = sf.unit
          charge.num = this.getLCLQuotationChargeDetailNum(sf.unit)
          let isMin = false
          charge.costRate = sf.costRate
          if (this.filterLevel === '0') {
            charge.rate = sf.costRate === PriceConstant.NIL ? 0 : Number(sf.costRate || 0)
            charge.amount = charge.num * charge.rate
            if (sf.costMin !== PriceConstant.NIL && !isNaN(sf.costMin) && charge.amount < sf.costMin) {
              charge.amount = Number(sf.costMin || 0)
              isMin = true
            }
          } else if (this.filterLevel === '1') {
            charge.rate = sf.coloaderRate === PriceConstant.NIL ? 0 : Number(sf.coloaderRate || 0)
            charge.amount = charge.num * charge.rate
            if (sf.coloaderMin !== PriceConstant.NIL && !isNaN(sf.coloaderMin) && charge.amount < sf.coloaderMin) {
              charge.amount = Number(sf.coloaderMin || 0)
              isMin = true
            }
          } else if (this.filterLevel === '2') {
            charge.rate = sf.customerRate === PriceConstant.NIL ? 0 : Number(sf.customerRate || 0)
            charge.amount = charge.num * charge.rate
            if (sf.customerMin !== PriceConstant.NIL && !isNaN(sf.customerMin) && charge.amount < sf.customerMin) {
              charge.amount = Number(sf.customerMin || 0)
              isMin = true
            }
          } else if (this.filterLevel === '99') {
            charge.rate = sf.t3Rate === PriceConstant.NIL ? 0 : Number(sf.t3Rate || 0)
            charge.amount = charge.num * charge.rate
            if (sf.t3Min !== PriceConstant.NIL && !isNaN(sf.t3Min) && charge.amount < sf.t3Min) {
              charge.amount = Number(sf.t3Min || 0)
              isMin = true
            }
          }
          if (isMin) {
            charge.costRate = sf.costMin
            charge.unit = ChargeMeasure.SHIPMENT_CHARGE_MEASURE.code
            charge.num = 1
            charge.rate = charge.amount
          }
          charge.remarks = sf.remarks
          charges.push(charge)
        }
      }
      this.charge.rowData = charges
    },
    // 去掉与ETD不符的附加费
    getUnconflictSurcharges(source = []) {
      let surcharge
      let isConflict = false
      const map = {}
      let hash
      let arr = []
      for (surcharge of source) {
        hash = surcharge.chargeType + '_' + surcharge.chargeScaleCode
        if (map.hasOwnProperty(hash)) {
          isConflict = true
          break
        } else {
          map[hash] = true
        }
      }
      if (isConflict) {
        arr = []
        const etd = this.quotation.beginDate
        const etdNow = moment(etd).format('YYYY-MM-DD')
        for (surcharge of source) {
          if (surcharge.beginDate <= etdNow && surcharge.endDate >= etdNow) {
            arr.push(surcharge)
          }
        }
        return Array.from(arr)
      }
      return source
    },
    // 组装整箱附加费查询的条件
    getSurchargeQueryProxy(qf) {
      const proxy = {}
      const currentTenant = this.$store.getters.tenantId
      const priceFcl = qf || {}
      if (priceFcl.tenantId > 0 && priceFcl.tenantId !== currentTenant) {
        proxy.tenantId = currentTenant
      }
      proxy.pol = qf.pol
      proxy.pod = qf.pod
      const pt = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', qf.pod)
      if (pt && pt.region) {
        proxy.rod = pt.region
      }
      proxy.carriers = qf.carrier
      proxy.bookingAgents = this.quotation.bookingAgent
      proxy.eqType = qf.eqType
      proxy.beginDate = priceFcl.beginDate
      proxy.endDate = priceFcl.endDate
      proxy.isDirect = !priceFcl.via
      proxy.via = priceFcl.via
      proxy.dangerous = this.quotation.dangerousGoods
      return proxy
    },
    // 组装整箱附加费查询的条件
    getSurchargeQueryProxy2(qf) {
      const proxy = {}
      const priceFcl = qf || {}
      proxy.pol = qf.pol
      proxy.pod = qf.pod
      const pt = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', qf.pod)
      if (pt && pt.region) {
        proxy.region = pt.region
      }
      proxy.carrier = qf.carrier
      proxy.bookingAgent = this.quotation.bookingAgent
      proxy.eqType = qf.eqType
      proxy.beginDate = priceFcl.beginDate
      proxy.endDate = priceFcl.endDate
      proxy.direct = !priceFcl.via
      proxy.via = priceFcl.via
      proxy.dangerous = this.quotation.dangerousGoods
      proxy.freightType = this.quotation.freightType
      return proxy
    },
    // 查询拼箱目的港费用
    async queryLclQuotationCharge() {
      let ql
      if (this.priceSource.length === 1) {
        ql = new QuotationLclDetail(this.priceSource[0])
        await queryEffectivePodCharge(this.getEffectivePodChargeQueryProxy(ql)).then(res => {
          this.onPodChargeLoaded(res.data)
        })
      } else {
        // todo flex端未找到对应的后端接口，H5这边先屏蔽
        // const paramMap = {}
        // for (ql in this.priceSource) {
        //   if (!paramMap.hasOwnProperty(ql.uuid)) {
        //     paramMap[ql.uuid] = this.getEffectivePodChargeQueryProxy(ql)
        //   }
        // }
        // await queryEffectivePodCharge2(this.getEffectivePodChargeQueryProxy(ql)).then(res => {
        //   this.onPodChargeLoaded(res.data)
        // })
      }
    },
    onPodChargeLoaded(arr) {
      const charges = []
      let charge = null
      let chargeItem = null
      if (arr && arr.length > 0) {
        const arrNew = []
        for (let i = 0; i < arr.length; i++) {
          const podCharge = arr[i]
          if (podCharge.coloaderRate === PriceConstant.NIL) {
            continue
          }
          arrNew.push(podCharge)
        }
        arr = arrNew
        if (arr && arr.length > 0) {
          arr = sortByMultiField(arr, ['feeIndex'], false)
        }

        for (const pc of arr) {
          charge = new QuotationChargeDetail().fillDefaultValue().getData()
          chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', pc.chargeScaleCode)
          if (chargeItem) {
            charge.chargeId = chargeItem.itemId
            charge.chargeName = chargeItem.scaleCode
            charge.type = parseInt(this.typeMap[pc.chargeType])
            charge.currency = pc.currency
            charge.rate = pc.coloaderRate
            charge.costRate = pc.coloaderRate
            charge.unit = pc.unit
            charge.num = this.getLCLQuotationChargeDetailNum(pc.unit)
            charge.amount = charge.num * charge.rate
            charge.remarks = pc.remarks
            charges.push(charge)
          }
        }
      }
      this.charge.rowData = charges
    },
    getLCLQuotationChargeDetailNum(unit) {
      switch (unit) {
        case ChargeMeasure.WGT_CHARGE_MEASURE.code:
          return this.quotation.grossWeight
        case ChargeMeasure.WGTX_CHARGE_MEASURE.code:
          return this.quotation.chargeWeight
        case ChargeMeasure.VOL_CHARGE_MEASURE.code:
          return this.quotation.cubage
        default:
          return 1
      }
    },
    getEffectivePodChargeQueryProxy(qf) {
      const proxy = {}
      const priceLcl = qf.priceLcl || {}
      proxy.pol = qf.pol
      proxy.pod = qf.pod
      const pt = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', qf.pod)
      if (pt && pt.region) {
        proxy.rod = pt.region
      }
      proxy.bookingAgent = priceLcl.bookingAgent
      proxy.beginDate = qf.beginDate
      proxy.endDate = qf.endDate
      return proxy
    },
    // 验证基础信息是否填好
    checkBasicInfo() {
      if ((!this.quotation.clientId || this.quotation.clientId <= 0) && !this.associatedInquiry) {
        this.$message.warning(this.$t('Pricing.PlsInputClient'))
        if (this.quotation.clientType === 0) this.$refs['quotationLsName'].$refs.advanceSelectRef.focus()
        if (this.quotation.clientType === 1) this.$refs['quotationZsName'].$refs.advanceSelectRef.focus()
        return false
      }
      if (!this.quotation.pol) {
        this.$message.warning(this.$t('Pricing.POLIsNull'))
        if (this.quotationType !== PriceConstant.QUOTATION_AIR) this.$refs['quotationSePol'].$refs.advanceSelectRef.focus()
        if (this.quotationType === PriceConstant.QUOTATION_AIR) this.$refs['quotationAirPol'].$refs.advanceSelectRef.focus()
        return false
      }
      if (!this.quotation.pod) {
        this.$message.warning(this.$t('Pricing.PODIsNull'))
        if (this.quotationType !== PriceConstant.QUOTATION_AIR) this.$refs['quotationSePod'].$refs.advanceSelectRef.focus()
        if (this.quotationType === PriceConstant.QUOTATION_AIR) this.$refs['quotationAirPod'].$refs.advanceSelectRef.focus()
        return false
      }
      if ((!this.quotation.contact || !this.quotation.phone) && !this.associatedInquiry) {
        this.$message.warning(this.$t('Pricing.PlsInputPersonalInfo'))
        if (!this.quotation.contact) this.$refs['quotationContact'].focus()
        if (!this.quotation.phone) this.$refs['quotationPhone'].focus()
        return false
      }
      return true
    },
    // 获取当前配置名称
    getCfgName() {
      let cfgName = ''
      if (this.quotationType === PriceConstant.QUOTATION_FCL) {
        cfgName = 'QFPopUp'
      } else if (this.quotationType === PriceConstant.QUOTATION_AIR) {
        cfgName = 'QAPopUp'
      } else {
        cfgName = 'QLPopUp'
      }
      return cfgName
    },
    // 保存配置
    saveConfig(key, configValue) {
      const cfgName = this.getCfgName()
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      config[key] = configValue
      LocalStorageUtils.setConfiguration(cfgName, config)
    },

    // ========================基础信息处理=====================================
    // 新增临时客户处理
    // 件毛体修改
    // 修改POL
    polChange(item) {
      this.quotation.pol = item.value
      this.syncPolPod('POL')
    },
    // 修改POD
    podChange(item) {
      this.quotation.pod = item.value
      this.syncCommerceCode()
      this.syncPolPod('POD')
    },
    syncCommerceCode() {
      if ([PriceConstant.QUOTATION_FCL, PriceConstant.QUOTATION_LCL].indexOf(this.quotation.type) > -1) {
        this.quotation.commerceCode = JobUtils.getLineByPort(this.quotation.pod, SystemConstants.PORT_TYPE_SEAPORT.code)
      } else if (PriceConstant.QUOTATION_AIR === this.quotation.type) {
        this.quotation.commerceCode = JobUtils.getLineByPort(this.quotation.pod, SystemConstants.PORT_TYPE_AIRPORT.code)
      }
    },
    // 同步运价信息POL/POD
    syncPolPod(type) {
      let source = null
      if (this.quotation.type === PriceConstant.QUOTATION_FCL) { // 整箱
        source = this.fcl.rowData // 整箱运价信息
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) { // 空运
        source = this.air.rowData // 整箱运价信息
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) { // 拼箱
        source = this.lcl.rowData // 整箱运价信息
      }
      if (source && source.length > 0) {
        for (const item of source) {
          if (type === 'POL') {
            item.pol = this.quotation.pol
            item.updated = true
          } else if (type === 'POD') {
            item.pod = this.quotation.pod
            item.updated = true
          }
        }
        if (this.quotation.type === PriceConstant.QUOTATION_FCL) { // 整箱
          this.fcl.gridApi.refreshCells({ force: true })
        } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) { // 空运
          this.air.gridApi.refreshCells({ force: true })
        } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) { // 拼箱
          this.lcl.gridApi.refreshCells({ force: true })
        }
      }
    },
    onNumChanged() {
      if (this.quotation && this.quotation.type === PriceConstant.QUOTATION_FCL && this.priceSource && this.priceSource.length > 0) {
        for (const price of this.fclRowData) {
          try {
            price.amount = this.quotation.num20 * Number(price.eq20 || 0) + this.quotation.num40 * Number(price.eq40 || 0) + this.quotation.numHc * Number(price.eqHc || 0) + this.quotation.num45 * Number(price.eq45 || 0)
            // CARGO-42265 荣圣达：报价管理创建报价单时运费的费用合计不自动计算
            price.updated = true
            if (this.fcl.gridApi) {
              this.fcl.gridApi.refreshCells({ force: true })
            }
          } catch (error) {
            this.$message.error(this.$t('Pricing.ErrorRaised'))
          }
        }
      }
    },
    // 切换订舱代理
    bookingAgentChangeHandler(item) {
      this.quotation.bookingAgent = item.value
    },
    // 重新计算件毛体
    calculateChargeWeight() {
      let weight = parseFloat(this.quotation.grossWeight)
      const cubage = parseFloat(this.quotation.cubage)

      if (!this.editing) return
      if (isNaN(weight) || isNaN(cubage)) return
      if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
        const cWeightIsCeil = Number(this.config.get('AEcWeightCeil')) // 计费重量是否取整
        const chargedWeight = JobUtils.calcChargeWeight(weight, cubage, true, cWeightIsCeil)
        this.quotation.chargeWeight = chargedWeight.toFixed(3)
        this.syncChargeWeightToCharge()
      }
      if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
        weight = weight / 1000
        if (cubage > weight) {
          weight = cubage
        }
        if (weight > 0 && weight < 1) {
          weight = 1.00
        }
        this.quotation.chargeWeight = weight.toFixed(3)
        this.syncChargeWeightToCharge()
      } else if (this.quotation.type === PriceConstant.QUOTATION_LCL) {
        if (this.quotation.volumeWeightRatio && Number(this.quotation.volumeWeightRatio)) {
          weight = NumberUtils.ToFixed2(weight / this.quotation.volumeWeightRatio, 3)
        } else {
          weight = weight / 1000
        }
        if (cubage > weight) {
          weight = cubage
        }
        if (weight > 0 && weight < 1) {
          weight = 1.00
        }
        this.quotation.chargeWeight = weight.toFixed(3)
        this.syncChargeWeightToCharge()
      }
    },
    // 切换客户类型
    ddlClientTypeChangeHandler(value) {
      this.quotation.clientType = value
      this.quotation.contact = ''
      this.quotation.phone = ''
      this.quotation.email = ''
      this.quotation.fax = ''
      this.quotation.clientId = 0
    },
    // 切换客户 带出联系人信息
    async onClientChange(item) {
      // console.log('onClientChange=======', item)
      this.quotation.clientId = item.value
      if (this.quotation.clientType === 0) {
        const client = new QuotationClient(item)
        if (!client) return
        this.quotation.contact = client.contact
        this.quotation.phone = client.phone
        this.quotation.email = client.email
        this.quotation.fax = client.fax
      } else {
        const company = new Company(item)
        if (!company) return
        const contactList = company.uuid ? await company.getContacts() : []
        let contactDefault = null
        if (contactList && contactList.length > 0) {
          for (const contact of contactList) {
            if (contact.defaultContact) {
              contactDefault = contact
              break
            }
          }
          if (!contactDefault) contactDefault = contactList[0]
        }
        if (contactDefault) {
          this.quotation.contact = contactDefault.contactPerson
          this.quotation.phone = contactDefault.telephone
          this.quotation.email = contactDefault.email
          this.quotation.fax = contactDefault.fax
        }
      }
    },

    // ========================临时客户处理=====================================
    // 客户名称回调
    clientParentCallBack(obj) {
      this.client.quotationClient.name = obj.value
      this.client.disableQuotationClientName = ''
      if (this.client.quotationClient.name) {
        chineseNameIsExist({ chineseName: this.client.quotationClient.name, branchIds: '1,' + this.$store.getters.currentOfficeId }).then(res => {
          if (res.data) {
            this.$message.warning(this.$t('Message.PartnerAlreadyExistPleaseSelectOfficialCustomer'))
          }
        })
      }
    },
    // 新增临时客户
    async onAddClient() {
      await this.onRefreshClient()
      this.client.disableQuotationClientName = ''
      this.client.visible = true
    },
    // 保存
    async onSaveClient() {
      // 验证
      if (!this.client.quotationClient.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterClientName'))
        this.$refs['clientName'].$refs.advanceSelectRef.focus()
        return
      }
      if (!this.client.quotationClient.contact) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseAddContactPerson'))
        this.$refs['clientContact'].focus()
        return
      }
      if (!this.client.quotationClient.phone) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseAddTelNumbers'))
        this.$refs['clientPhone'].focus()
        return
      }
      let res = await chineseNameIsExist({ chineseName: this.client.quotationClient.name, branchIds: '1,' + this.$store.getters.currentOfficeId })
      if (res.data) {
        this.$message.error(this.$t('Message.PartnerAlreadyExistPleaseSelectOfficialCustomer') + '！')
        this.$refs['clientName'].$refs.advanceSelectRef.focus()
        return
      }
      if (Number(parseInt(this.config.get('PartnerManagementMode'))) === 0) {
        res = await chineseNameIsExist({ chineseName: this.client.quotationClient.name })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Message.PartnerHasMaintainedUndeToContinue', { officeCode: this.branchMap.get(res.data.branchId) }), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Message.Yes'),
            cancelButtonText: this.$t('Message.No'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (flag) {
            this.client.disableQuotationClientName = ''
          } else {
            this.client.disableQuotationClientName = this.client.quotationClient.name
            return
          }
        }
      } else {
        this.client.disableQuotationClientName = ''
      }

      // 赋默认值
      if (!this.client.quotationClient.uuid) {
        this.client.quotationClient.branchId = this.$store.getters.currentOffice.officeId
        this.client.quotationClient.createdBy = this.$store.getters.userInfo.userId
        this.client.quotationClient.dateCreated = new Date()
      }
      this.client.quotationClient.firstMeetDate = new Date()
      this.client.quotationClient.customerStatusCode = '0'
      this.client.quotationClient.active = true

      // 保存到数据库
      const body = { quotationClient: this.client.quotationClient }
      saveQuotationClient(body).then(res => {
        const result = res.data
        if (result) {
          Object.assign(this.client.quotationClient, result)
          this.onNewClientAdded()
        }
      })
      this.onCancelClient(false)
    },
    // 临时客户保存之后处理
    onNewClientAdded() {
      const client = this.client.quotationClient
      if (client) {
        // 更新临时客户下拉数据源
        let currentClient = this.filter.clientList.find(item => {
          return item.clientId === client.clientId
        })
        if (!currentClient) this.filter.clientList.push(client)
        if (currentClient) currentClient = client

        this.quotation.clientId = client.clientId
        this.quotation.contact = client.contact
        this.quotation.phone = client.phone
        this.quotation.email = client.email
        this.quotation.fax = client.fax
      }
    },
    // 取消
    onCancelClient(isClear = true) {
      if (isClear) this.client.quotationClient = new QuotationClient().fillDefaultValue().getData()
      this.client.visible = false
    },
    // 刷新
    async onRefreshClient() {
      const name = this.client.quotationClient.name
      if (!this.client.quotationClient || !this.client.quotationClient.uuid) {
        this.client.quotationClient = new QuotationClient().fillDefaultValue().getData()
        this.client.quotationClient.ownerId = this.$store.getters.userId
      } else {
        const jobModel = new QuotationClient(this.client.quotationClient)
        if (this.client.quotationClient.uuid) {
          await jobModel.loadQuotationClientRelated({ client: true })
        }
      }
      this.client.quotationClient.name = name
    },

    // ========================运价信息公共处理=====================================
    // 新增运价
    onAdd_P() {
      const pol = this.quotation.pol
      const pod = this.quotation.pod
      if (!pol || !pod) {
        this.$message.warning(this.$t('Pricing.PlsInputPOLPOD'))
        if (!pol) {
          if (this.quotationType !== PriceConstant.QUOTATION_AIR) this.$refs['quotationSePol'].$refs.advanceSelectRef.focus()
          if (this.quotationType === PriceConstant.QUOTATION_AIR) this.$refs['quotationAirPol'].$refs.advanceSelectRef.focus()
        } else {
          if (this.quotationType !== PriceConstant.QUOTATION_AIR) this.$refs['quotationSePod'].$refs.advanceSelectRef.focus()
          if (this.quotationType === PriceConstant.QUOTATION_AIR) this.$refs['quotationAirPod'].$refs.advanceSelectRef.focus()
        }
        return
      }
      let price = null
      if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
        price = this.createQuotationFcl(pol, pod)
        if (!this.fcl.rowData) this.fcl.rowData = []
        this.fcl.rowData.push(price)
        this.fcl.selectedRow = price
        this.fcl.gridApi.setFocusedCell(this.fclRowData.length - 1)
        this.fcl.gridApi.refreshCells({ force: true })
      } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
        price = this.createQuotationAir(pol, pod)
        if (!this.air.rowData) this.air.rowData = []
        this.air.rowData.push(price)
        this.air.selectedRow = price
        this.air.gridApi.setFocusedCell(this.airRowData.length - 1)
        this.air.gridApi.refreshCells({ force: true })
      } else {
        price = this.createQuotationLcl(pol, pod)
        if (!this.lcl.rowData) this.lcl.rowData = []
        this.lcl.rowData.push(price)
        this.lcl.selectedRow = price
        this.lcl.gridApi.setFocusedCell(this.lclRowData.length - 1)
        this.lcl.gridApi.refreshCells({ force: true })
      }
    },
    // 删除运价
    onDelete_P() {
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        if (this.quotation.type === PriceConstant.QUOTATION_FCL) {
          this.deletePriceFcl()
        } else if (this.quotation.type === PriceConstant.QUOTATION_AIR) {
          this.deletePriceAir()
        } else {
          this.deletePriceLcl()
        }
        this.priceSource = null
      }).catch(() => { })
    },
    // 统一加价
    onMarkup() {
      this.$confirm(this.$t('Pricing.IsMarkup'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let markups = null
        let fields = null
        let field = null
        let price = 0
        switch (this.quotation.type) {
          case PriceConstant.QUOTATION_FCL:
            markups = this.getFclMarkups()
            fields = ['eq20', 'eq40', 'eqHc', 'eq45']
            for (const qf of this.fclRowData) {
              for (const key in fields) {
                field = fields[key]
                if (!qf[field]) continue
                qf[field] = String(Number(qf[field]) + markups[field])
              }
            }
            this.onNumChanged()
            this.fcl.gridApi.refreshCells({ force: true })
            break
          case PriceConstant.QUOTATION_AIR:
            markups = this.getAirMarkups()
            fields = ['minCharge', 'step', 'p45', 'p100', 'p300', 'p500', 'p1000']
            for (const qa of this.airRowData) {
              for (const key in fields) {
                field = fields[key]
                if (qa[field] !== PriceConstant.TACT && qa[field] !== PriceConstant.NIL) {
                  qa[field] = this.$numeral(Number(qa[field]) + Number(markups[field])).format('0.00')
                }
              }
            }
            this.air.gridApi.refreshCells({ force: true })
            break
          case PriceConstant.QUOTATION_LCL:
            markups = this.getLclMarkups()
            fields = ['weightPrice', 'volumePrice']
            price = 0
            for (const ql of this.lclRowData) {
              for (const key in fields) {
                field = fields[key]
                price = Number(ql[field])
                if (isNaN(price)) continue
                if (!markups[field]) {
                  markups[field] = 0
                }
                ql[field] = String(price + markups[field])
              }
            }
            this.lcl.gridApi.refreshCells({ force: true })
            break
          default:
            break
        }
      }).catch(() => { })
    },

    // ========================整箱运价信息处理=====================================
    // 整箱列修改
    onFclCellChange(params) {
      const price = params.data
      switch (params.colDef.field) {
        case 'eq20':
        case 'eq40':
        case 'eqHc':
        case 'eq45': {
          this.updateFclAmount(price)
          break
        }
        case 'vat': { // 税率处理
          if (price.vat && parseInt(price.vat) > 10) {
            price.vat = 10
            break
          }
          if (!price.vat || (price.vat && parseInt(price.vat) < 0)) {
            price.vat = 0
            break
          }
          break
        }
        case 'closingDay': // 截关日期处理
        case 'departureDay': { // 截关日期处理
          if (!price[params.colDef.field]) {
            price[params.colDef.field] = ''
            break
          }
          price[params.colDef.field] = price[params.colDef.field].replace(/,/g, '')
          const rs = []
          const len = price[params.colDef.field].length
          let ch = ''
          for (let i = 0; i < len; i++) {
            ch = price[params.colDef.field].charAt(i)
            if (!isNumber(ch) || parseInt(ch) > 7 || parseInt(ch) < 1) continue
            if (rs.indexOf(ch) < 0) {
              rs.push(ch)
            }
          }
          price[params.colDef.field] = rs.join(',')
          break
        }
        default: {
          break
        }
      }
      if (price.uuid) price.updated = true // 更新标识
      this.fcl.gridApi.refreshCells({ force: true })
    },
    // 保存验证
    checkPricesFcl() {
      const source = this.fclRowData
      if (!source || source.length <= 0) return true
      let flag = true
      this.fcl.gridApi.forEachNode(node => {
        if (!flag) return
        const price = node.data
        const rowIndex = node.rowIndex
        if (!price.pol) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POL']))
          this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }
        if (!price.pod) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POD']))
          this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
          flag = false
          return false
        }
        if (price.pol === price.pod) {
          this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'POD']))
          this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }

        if (price.via) {
          if (price.pol === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'VIA']))
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
            flag = false
            return false
          }
          if (price.pod === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POD', 'VIA']))
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
            flag = false
            return false
          }
        }
        if (!price.carrier || price.carrier < 1) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Carrier')]))
          this.fcl.gridApi.ensureColumnVisible('carrier')
          this.fcl.gridApi.ensureIndexVisible(rowIndex)
          this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'carrier' })
          flag = false
          return false
        }
        if (!price.days) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Days')]))
          this.fcl.gridApi.ensureColumnVisible('days')
          this.fcl.gridApi.ensureIndexVisible(rowIndex)
          this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'days' })
          flag = false
          return false
        }
        if (price.freightType === PriceConstant.PRICE_TYPE_SPOT.code) {
          // 校验 spot运价时，数据必填项
          if (!price.vessel) {
            this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('SeaExport.Vessel')]))
            this.fcl.gridApi.ensureColumnVisible('vessel')
            this.fcl.gridApi.ensureIndexVisible(rowIndex)
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'vessel' })
            flag = false
            return false
          }
          if (!price.voyageFlight) {
            this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('SeaExport.Voyage')]))
            this.fcl.gridApi.ensureColumnVisible('voyageFlight')
            this.fcl.gridApi.ensureIndexVisible(rowIndex)
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'voyageFlight' })
            flag = false
            return false
          }
          if (!price.etd) {
            this.$message.warning(this.$t('Pricing.PlsInput', ['ETD']))
            this.fcl.gridApi.ensureColumnVisible('etd')
            this.fcl.gridApi.ensureIndexVisible(rowIndex)
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'etd' })
            flag = false
            return false
          }
          if (!price.eta) {
            this.$message.warning(this.$t('Pricing.PlsInput', ['ETA']))
            this.fcl.gridApi.ensureColumnVisible('eta')
            this.fcl.gridApi.ensureIndexVisible(rowIndex)
            this.fcl.gridApi.startEditingCell({ rowIndex, colKey: 'eta' })
            flag = false
            return false
          }
          if (price.etd && price.eta) { // 将日期字符串转换为日期对象
            const etd = new Date(price.etd)
            const eta = new Date(price.eta) // 比较两个日期对象的大小
            if (etd > eta) { // 如果 price.eta 时间早于 price.etd，则提示错误信息
              this.$message.warning(this.$t('Pricing.EtaMustBeLaterThanOrEqualToEtd'))
              flag = false
              return false
            }
          }
        }
        return true
      })
      return flag
    },
    saveConfigFcl() {
      const cfgName = 'QFPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      const markups = config['qfMarkup'] || {}
      markups.eq20 = this.qfMarkups.eq20
      markups.eq40 = this.qfMarkups.eq40
      markups.eqHc = this.qfMarkups.eqHc
      markups.eq45 = this.qfMarkups.eq45
      this.saveConfig('qfMarkup', markups)
    },
    readConfigFcl() {
      const cfgName = 'QFPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      let markups = config['qfMarkup']
      if (!markups) {
        markups = {}
        this.clearFcl()
      }
      this.qfMarkups.eq20 = Number(markups['eq20']) || 0
      this.qfMarkups.eq40 = Number(markups['eq40']) || 0
      this.qfMarkups.eqHc = Number(markups['eqHc']) || 0
      this.qfMarkups.eq45 = Number(markups['eq45']) || 0
    },
    clearFcl() {
      this.qfMarkups.eq20 = 0
      this.qfMarkups.eq40 = 0
      this.qfMarkups.eqHc = 0
      this.qfMarkups.eq45 = 0
    },
    getFclMarkups() {
      const markups = {}
      markups.eq20 = this.qfMarkups.eq20 || 0
      markups.eq40 = this.qfMarkups.eq40 || 0
      markups.eqHc = this.qfMarkups.eqHc || 0
      markups.eq45 = this.qfMarkups.eq45 || 0
      return markups
    },
    // 删除整箱运价
    deletePriceFcl() {
      if (!this.fcl.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.fcl.selectedRow.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
        this.fcl.selectedRow.deleted = true // deleted 是否需要更新标识
        const tempRowData = this.fcl.rowData
        this.fcl.rowData = []
        this.$nextTick(() => {
          this.fcl.rowData = tempRowData
        })
      } else {
        const index = this.fcl.rowData.findIndex(p => p === this.fcl.selectedRow)
        if (index > -1) {
          this.fcl.rowData.splice(index, 1)
        }
      }
      setTimeout(() => {
        this.fcl.gridApi.setFocusedCell(0)
        this.fcl.selectedRow = null
        if (this.fclRowData && this.fclRowData.length > 0) {
          this.fcl.selectedRow = this.fclRowData[0]
        }
      }, 100)
      this.fcl.gridApi.refreshCells({ force: true })
    },
    // 创建整箱
    createQuotationFcl(pol = '', pod = '') {
      const qf = new QuotationFclDetail().fillDefaultValue().getData()
      qf.quotationUuid = this.quotation.uuid
      qf.level = -1 // 新增的价格，运价等级不知道，写为-1
      qf.pol = pol
      qf.pod = pod
      qf.via = ''
      qf.eqType = 'GP'
      qf.eq20 = ''
      qf.eq40 = ''
      qf.eqHc = ''
      qf.eq45 = ''
      qf.cost20 = ''
      qf.cost40 = ''
      qf.costHc = ''
      qf.cost45 = ''
      qf.term = 'P'
      qf.lane = ''
      qf.days = ''

      qf.beginDate = new Date()
      qf.endDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      qf.serviceMode = ''
      qf.currency = 'USD'
      qf.remarks = ''
      qf.commodity = ''
      return qf
    },
    // 费用合计
    updateFclAmount(price) {
      try {
        price.amount = this.quotation.num20 * Number(price.eq20 || 0) + this.quotation.num40 * Number(price.eq40 || 0) + this.quotation.numHc * Number(price.eqHc || 0) + this.quotation.num45 * Number(price.eq45 || 0)
      } catch (error) {
        this.$message.error(this.$t('Pricing.ErrorRaised'))
      }
    },

    // ========================拼箱运价信息处理=====================================
    // 拼箱列修改
    onLclCellChange(params) {
      const price = params.data
      switch (params.colDef.field) {
        case 'closingDay': // 截关日期处理
        case 'departureDay': { // 截关日期处理
          if (!price[params.colDef.field]) {
            price[params.colDef.field] = ''
            break
          }
          price[params.colDef.field] = price[params.colDef.field].replace(/,/g, '')
          const rs = []
          const len = price[params.colDef.field].length
          let ch = ''
          for (let i = 0; i < len; i++) {
            ch = price[params.colDef.field].charAt(i)
            if (!isNumber(ch) || parseInt(ch) > 7 || parseInt(ch) < 1) continue
            if (rs.indexOf(ch) < 0) {
              rs.push(ch)
            }
          }
          price[params.colDef.field] = rs.join(',')
          break
        }
        case 'carrier':
          /* if (price[params.colDef.field] && price[params.colDef.field].length > 0) {
            price[params.colDef.field] = price[params.colDef.field].join(',')
          }*/
          console.log('params==========', params)
          break
        default: {
          break
        }
      }
      if (price.uuid) price.updated = true // 更新标识
      this.lcl.gridApi.refreshCells({ force: true })
    },
    // 保存验证
    checkPricesLcl() {
      const source = this.lclRowData
      if (!source || source.length <= 0) return true
      let flag = true
      this.lcl.gridApi.forEachNode(node => {
        if (!flag) return
        const price = node.data
        const rowIndex = node.rowIndex
        if (!price.source) {
          price.source = 0
        }
        if (!price.pol) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POL']))
          this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }
        if (!price.pod) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POD']))
          this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
          flag = false
          return false
        }
        if (price.pol === price.pod) {
          this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'POD']))
          this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }

        if (price.via) {
          if (price.pol === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'VIA']))
            this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
            flag = false
            return false
          }
          if (price.pod === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POD', 'VIA']))
            this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
            flag = false
            return false
          }
        }
        if (!price.carrier || price.carrier < 1) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Carrier')]))
          this.lcl.gridApi.ensureColumnVisible('carrier')
          this.lcl.gridApi.ensureIndexVisible(rowIndex)
          this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'carrier' })
          flag = false
          return false
        }
        if (!price.days) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Days')]))
          this.lcl.gridApi.ensureColumnVisible('days')
          this.lcl.gridApi.ensureIndexVisible(rowIndex)
          this.lcl.gridApi.startEditingCell({ rowIndex, colKey: 'days' })
          flag = false
          return false
        }
        return true
      })
      return flag
    },
    saveConfigLcl() {
      const cfgName = 'QLPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      const markups = config['qlMarkup'] || {}
      markups.weightPrice = this.qlMarkups.weightPrice
      markups.volumePrice = this.qlMarkups.volumePrice
      this.saveConfig('qlMarkup', markups)
    },
    readConfigLcl() {
      const cfgName = 'QLPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      let markups = config['qlMarkup']
      if (!markups) {
        markups = {}
        this.clearLcl()
      }
      this.qlMarkups.weightPrice = Number(markups['weightPrice']) || 0
      this.qlMarkups.volumePrice = Number(markups['volumePrice']) || 0
    },
    clearLcl() {
      this.qlMarkups.weightPrice = 0
      this.qlMarkups.volumePrice = 0
    },
    getLclMarkups() {
      const markups = {}
      markups.weightPrice = this.qlMarkups.weightPrice
      markups.volumePrice = this.qlMarkups.volumePrice
      return markups
    },
    // 删除拼箱运价
    deletePriceLcl() {
      if (!this.lcl.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.lcl.selectedRow.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
        this.lcl.selectedRow.deleted = true // deleted 是否需要更新标识
        const tempRowData = this.lcl.rowData
        this.lcl.rowData = []
        this.$nextTick(() => {
          this.lcl.rowData = tempRowData
        })
      } else {
        const index = this.lcl.rowData.findIndex(p => p === this.lcl.selectedRow)
        if (index > -1) {
          this.lcl.rowData.splice(index, 1)
        }
      }
      setTimeout(() => {
        this.lcl.gridApi.setFocusedCell(0)
        this.lcl.selectedRow = null
        if (this.lclRowData && this.lclRowData.length > 0) {
          this.lcl.selectedRow = this.lclRowData[0]
        }
      }, 100)
      this.lcl.gridApi.refreshCells({ force: true })
    },
    // 创建拼箱
    createQuotationLcl(pol = '', pod = '') {
      const ql = new QuotationLclDetail().fillDefaultValue().getData()
      ql.quotationUuid = this.quotation.uuid
      ql.level = -1// 新增的价格，运价等级不知道，写为-1
      ql.pol = pol
      ql.pod = pod
      ql.via = ''
      ql.source = -99
      ql.weightPrice = 0.00
      ql.volumePrice = 0.00
      ql.weightCost = 0.00
      ql.volumeCost = 0.00
      ql.term = 'P'

      ql.beginDate = new Date()
      ql.endDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      ql.currency = 'USD'
      ql.remarks = ''

      return ql
    },

    // ========================空运运价信息处理=====================================
    // 空运列修改
    onAirCellChange(params) {
      const price = params.data
      switch (params.colDef.field) {
        case 'frequency8': {
          price[params.colDef.field] = price[params.colDef.field].replace(/,/g, '')
          let rs = []
          const len = price[params.colDef.field].length
          let ch = ''
          for (let i = 0; i < len; i++) {
            ch = price[params.colDef.field].charAt(i)
            if (!isNumber(ch) || parseInt(ch) > 7 || parseInt(ch) < 1) continue
            if (rs.indexOf(ch) < 0) {
              rs.push(ch)
            }
          }
          rs = rs.sort((a, b) => {
            return a - b
          })
          for (let i = 1; i < 7; i++) {
            price['frequency' + i] = ''
          }
          if (rs && rs.length > 0) {
            for (let i = 0; i < rs.length; i++) {
              const curValue = rs[i]
              price['frequency' + curValue] = true
            }
          }
          price[params.colDef.field] = rs.join('/')
          break
        }
        case 'flight': {
          price.aircraft = price.flight
          break
        }
        default: {
          break
        }
      }
      if (price.uuid) price.updated = true // 更新标识
      this.air.gridApi.refreshCells({ force: true })
    },
    // 保存验证
    checkPricesAir() {
      const source = this.airRowData
      if (!source || source.length <= 0) return true
      let flag = true
      this.air.gridApi.forEachNode(node => {
        if (!flag) return
        const price = node.data
        const rowIndex = node.rowIndex
        if (!price.pol) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POL']))
          this.air.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }
        if (!price.pod) {
          this.$message.warning(this.$t('Pricing.PlsInput', ['POD']))
          this.air.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
          flag = false
          return false
        }
        if (price.pol === price.pod) {
          this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'POD']))
          this.air.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
          flag = false
          return false
        }

        if (price.via) {
          if (price.pol === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POL', 'VIA']))
            this.air.gridApi.startEditingCell({ rowIndex, colKey: 'pol' })
            flag = false
            return false
          }
          if (price.pod === price.via) {
            this.$message.warning(this.$t('Pricing.MustDifferent', ['POD', 'VIA']))
            this.air.gridApi.startEditingCell({ rowIndex, colKey: 'pod' })
            flag = false
            return false
          }
        }
        if (!price.carrier || price.carrier < 1) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Carrier_Air')]))
          this.air.gridApi.ensureColumnVisible('carrier')
          this.air.gridApi.ensureIndexVisible(rowIndex)
          this.air.gridApi.startEditingCell({ rowIndex, colKey: 'carrier' })
          flag = false
          return false
        }
        if (!price.days) {
          this.$message.warning(this.$t('Pricing.PlsInput', [this.$t('Pricing.Days')]))
          this.air.gridApi.ensureColumnVisible('days')
          this.air.gridApi.ensureIndexVisible(rowIndex)
          this.air.gridApi.startEditingCell({ rowIndex, colKey: 'days' })
          flag = false
          return false
        }
        return true
      })
      return flag
    },
    saveConfigAir() {
      const cfgName = 'QAPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      const markups = config['qaMarkup'] || {}
      markups.minCharge = this.qaMarkups.minCharge
      markups.step = this.qaMarkups.step
      markups.p45 = this.qaMarkups.p45
      markups.p100 = this.qaMarkups.p100
      markups.p300 = this.qaMarkups.p300
      markups.p500 = this.qaMarkups.p500
      markups.p1000 = this.qaMarkups.p1000
      this.saveConfig('qaMarkup', markups)
    },
    readConfigAir() {
      const cfgName = 'QAPopUp'
      const config = LocalStorageUtils.getConfiguration(cfgName) || {}
      let markups = config['qaMarkup']
      if (!markups) {
        markups = {}
        this.clearAir()
      }
      this.qaMarkups.minCharge = Number(markups['minCharge']) || 0
      this.qaMarkups.step = Number(markups['step']) || 0
      this.qaMarkups.p45 = Number(markups['p45']) || 0
      this.qaMarkups.p100 = Number(markups['p100']) || 0
      this.qaMarkups.p300 = Number(markups['p300']) || 0
      this.qaMarkups.p500 = Number(markups['p500']) || 0
      this.qaMarkups.p1000 = Number(markups['p1000']) || 0
    },
    clearAir() {
      this.qaMarkups.minCharge = 0
      this.qaMarkups.step = 0
      this.qaMarkups.p45 = 0
      this.qaMarkups.p100 = 0
      this.qaMarkups.p300 = 0
      this.qaMarkups.p500 = 0
      this.qaMarkups.p1000 = 0
    },
    getAirMarkups() {
      const markups = {}
      markups.minCharge = this.qaMarkups.minCharge
      markups.step = this.qaMarkups.step
      markups.p45 = this.qaMarkups.p45
      markups.p100 = this.qaMarkups.p100
      markups.p300 = this.qaMarkups.p300
      markups.p500 = this.qaMarkups.p500
      markups.p1000 = this.qaMarkups.p1000
      return markups
    },
    // 删除空运运价
    deletePriceAir() {
      if (!this.air.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.air.selectedRow.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
        this.air.selectedRow.deleted = true // deleted 是否需要更新标识
        const tempRowData = this.air.rowData
        this.air.rowData = []
        this.$nextTick(() => {
          this.air.rowData = tempRowData
        })
      } else {
        const index = this.air.rowData.findIndex(p => p === this.air.selectedRow)
        if (index > -1) {
          this.air.rowData.splice(index, 1)
        }
      }
      setTimeout(() => {
        this.air.gridApi.setFocusedCell(0)
        this.air.selectedRow = null
        if (this.airRowData && this.airRowData.length > 0) {
          this.air.selectedRow = this.airRowData[0]
        }
      }, 100)
      this.air.gridApi.refreshCells({ force: true })
    },
    // 创建空运
    createQuotationAir(pol = '', pod = '') {
      const qa = new QuotationAirDetail().fillDefaultValue().getData()
      qa.quotationUuid = this.quotation.uuid
      qa.level = -1
      qa.flight = ''
      qa.aircraft = ''
      qa.pol = pol
      qa.pod = pod
      qa.via = ''
      qa.agent = ''
      const localCurrency = RateUtil.localCurrencyByOffice()
      qa.currency = localCurrency
      qa.minCharge = PriceConstant.NIL
      qa.step = PriceConstant.NIL
      qa.p45 = PriceConstant.NIL
      qa.p100 = PriceConstant.NIL
      qa.p300 = PriceConstant.NIL
      qa.p500 = PriceConstant.NIL
      qa.p1000 = PriceConstant.NIL
      qa.fsc = PriceConstant.NIL
      qa.ssc = PriceConstant.NIL
      qa.beginDate = new Date()
      qa.endDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      qa.remarks = ''
      qa.bookingAgent = 0
      return qa
    },

    // 整箱行点击
    onFclRowClicked(event) {
      if (!event || !event.data) return
      this.fcl.selectedRow = event.data
    },
    // 拼箱行点击
    onLclRowClicked(event) {
      if (!event || !event.data) return
      this.lcl.selectedRow = event.data
    },
    // 空运行点击
    onAirRowClicked(event) {
      if (!event || !event.data) return
      this.air.selectedRow = event.data
    },

    // ========================费用信息处理=====================================
    // 检查信息是否填写完整
    checkCharges() {
      const charges = this.charge.rowData
      if (!charges || charges.length <= 0) return true
      let flag = true
      this.charge.gridApi.forEachNode(node => {
        if (!flag) return
        const charge = node.data
        const rowIndex = node.rowIndex
        if (!charge.chargeId || (charge.chargeId && charge.chargeId < 1)) {
          this.$message.warning(this.$t('Pricing.FeeNameIsNull'))
          this.charge.gridApi.startEditingCell({ rowIndex, colKey: 'chargeId' })
          flag = false
          return false
        }
        if (!charge.unit) {
          this.$message.warning(this.$t('Pricing.FeeUnitIsNull'))
          this.charge.gridApi.startEditingCell({ rowIndex, colKey: 'unit' })
          flag = false
          return false
        }
        return true
      })
      return flag
    },
    // 币种切换【存缓存】
    currencyParentCallBack(item) {
      this.filter.currency = item.value
      this.saveConfig('currency_C', this.filter.currency)
    },
    // 费用列修改
    onChargeCellChange(params) {
      const charge = params.data
      switch (params.colDef.field) {
        case 'num': {
          this.updateChargeAmount(charge)
          break
        }
        case 'rate': {
          if (!charge.costRate || (charge.costRate && charge.costRate <= 0)) {
            charge.costRate = charge.rate
          }
          this.updateChargeAmount(charge)
          break
        }
        case 'unit': {
          this.updateChargeNum(charge)
          break
        }
        default: {
          break
        }
      }
      if (charge.uuid) charge.updated = true // 更新标识
      this.charge.gridApi.refreshCells({ force: true })
    },
    // 更新金额
    updateChargeAmount(charge) {
      charge.amount = charge.num * Number(charge.rate || 0)
    },
    // 更新数量
    updateChargeNum(charge) {
      if (!this.quotation || !charge) return
      // 空运费用 更新数量
      if (this.quotationType === PriceConstant.QUOTATION_AIR) {
        if (ChargeMeasure.WGTX_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.chargeWeight
        } else if (ChargeMeasure.VOL_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.cubage
        } else if (ChargeMeasure.WGT_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.grossWeight
        } else {
          charge.num = 1
        }
      } else {
        if (ChargeMeasure.C20_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.num20
        } else if (ChargeMeasure.C40_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.num40
        } else if (ChargeMeasure.C40H_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.numHc
        } else if (ChargeMeasure.C45_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.num45
        } else if (ChargeMeasure.WGTX_CHARGE_MEASURE.code === charge.unit) {
          charge.num = this.quotation.chargeWeight
        }
      }
      this.updateChargeAmount(charge)
    },
    // 新增费用
    onAdd_C() {
      const charge = this.createCharge(0)
      if (!this.charge.rowData) this.charge.rowData = []
      this.charge.rowData.push(charge)
      this.charge.selectedRow = charge
      this.charge.gridApi.setFocusedCell(this.chargeRowData.length - 1, 'type')
      this.charge.gridApi.refreshCells({ force: true })
    },
    getMaxSerialNumber() {
      let max = 0
      if (this.charge.rowData && this.charge.rowData.length > 0) {
        for (const c of this.charge.rowData) {
          if (c.serialNumber > max) {
            max = c.serialNumber
          }
        }
      }
      return max
    },
    refreshSerialNumberForCharge(e) {
      this.doRefreshSerialNumberForCharge()
    },
    doRefreshSerialNumberForCharge() {
      if (this.charge.gridApi) {
        this.charge.gridApi.forEachNode(node => {
          const charge = node.data
          charge.serialNumber = node.rowIndex + 1
        })
        this.charge.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 费用行点击
    onChargeRowClicked(event) {
      if (!event || !event.data) return
      this.charge.selectedRow = event.data
    },
    // 生成费用
    createCharge(type = 0) {
      const charge = new QuotationChargeDetail().fillDefaultValue().getData()
      charge.serialNumber = this.getMaxSerialNumber() + 1
      charge.quotationUuid = this.quotation.uuid
      charge.chargeName = ''
      charge.type = 0
      charge.currency = this.filter.currency
      charge.rate = 0.0
      charge.costRate = 0.0
      charge.num = 0.0
      charge.amount = 0.0
      charge.unit = ''
      charge.remarks = ''
      return charge
    },
    // 删除费用
    onDelete_C() {
      if (!this.charge.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.charge.selectedRow.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
        this.charge.selectedRow.deleted = true // deleted 是否需要更新标识
        const tempRowData = this.charge.rowData
        this.charge.rowData = []
        this.$nextTick(() => {
          this.charge.rowData = tempRowData
        })
      } else {
        const index = this.charge.rowData.findIndex(p => p === this.charge.selectedRow)
        if (index > -1) {
          this.charge.rowData.splice(index, 1)
        }
      }
      setTimeout(() => {
        this.charge.gridApi.setFocusedCell(0, 'type')
        this.charge.selectedRow = null
        if (this.chargeRowData && this.chargeRowData.length > 0) {
          this.charge.selectedRow = this.chargeRowData[0]
        }
      }, 100)
      this.charge.gridApi.refreshCells({ force: true })
    },
    // 费用单位过滤
    getChargeUnitFilter() {
      if (this.quotationType === PriceConstant.QUOTATION_AIR) {
        return { unit: true, airFreight: true }
      }
      if (this.quotationType !== PriceConstant.QUOTATION_AIR) {
        return { unit: true, seaFreight: true }
      }
    },
    // 计费重量变化，是否同步费用
    syncChargeWeightToCharge() {
      let chargeFlag = false
      for (const charge of this.charge.rowData) {
        if (charge.unit && charge.unit === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
          chargeFlag = true
          break
        }
      }
      if (chargeFlag) {
        this.$confirm(this.$t('Message.TheChargedWeightHasBeenChanged'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of this.charge.rowData) {
            if (charge.unit && charge.unit === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
              charge.num = this.quotation.chargeWeight
              this.updateChargeAmount(charge)
              if (charge.uuid) charge.updated = true // 更新标识
            }
          }
          this.charge.gridApi.refreshCells({ force: true })
        }).catch(() => {
        })
      }
    },

    // ========================文件信息处理=====================================
    // 文件信息查询
    toFileQuery() {
      this.file.storageURL = this.config.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>quotationUuid</key><value>' +
        this.fileCloudFileJob.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      getFileList(xmlParam).then(res => {
        const resData = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''
          }
        })
        this.getFilesSucceedHandler(resData)
      })
    },
    // 文件列表 父级和子级组装
    getFilesSucceedHandler: function(resData) {
      // 排序后放入临时对象数据
      const rowDataTempt = sortByMultiField(resData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!rowDataTempt || rowDataTempt.length === 0) {
        return
      }
      let fatherFile = rowDataTempt[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      fatherFile.hasParent = false
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < rowDataTempt.length; i++) {
        childFile = rowDataTempt[i]
        childFile.hasParent = false
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.parentId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      // 数据组装后 父级再次排序 根据createDate fileName
      let parentFileList = source.filter(val => {
        return val.hasParent === false
      })
      const childFileList = source.filter(val => {
        return val.hasParent === true
      })
      parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

      const fileList = [...parentFileList, ...childFileList]
      this.file.rowData = fileList
    },
    // 查看详情
    onFileView(value) {
      const fileObject = this.file.rowData.find(x => x.fileId === value)
      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.$store.getters.userInfo.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.$store.getters.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (!result || result.length === 0) {
        return true
      }

      if (this.$store.getters.isAdmin || parseInt(data.createdBy) === this.$store.getters.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.warning(this.$t('SeaExport.FileNotAllowedView').replace('{0}', data.fileName))
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToView').replace('{0}', data.fileName))
        return
      }
      return true
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    onFileTypeCellFocused(event) {
      if (event.column && event.column && event.column.colId === 'fileType') {
        if (!this.$store.getters.isAdmin) {
          if (Number(this.file.rowData[event.rowIndex].createdBy) !== this.$store.getters.userId) {
            return
          }
        }
        this.fileTypeEdit(this.file.rowData[event.rowIndex])
      }
    },
    fileTypeEdit(data) {
      this.file.fileTypeEditor.fileId = data.fileId
      this.file.fileTypeEditor.fileCategory = data.fileType
      this.file.fileTypeEditor.visible = true
    },
    // 文件类型 编辑保存
    itemEditEndHandler(data) {
      const item = this.file.rowData.find(p => p.fileId === data.fileId)

      const documentType = data.fileCategory
      const documentName = data.fileCategoryLabel // item.extendMetaData['documentName']
      const isShared = item.extendMetaData['isShared']
      const op = item.extendMetaData['op']
      const sales = item.extendMetaData['sales']
      const all = item.extendMetaData['other']
      const customer = item.extendMetaData['customer']
      const consignee = item.extendMetaData['consignee']
      const shipper = item.extendMetaData['shipper']
      const destinationAgent = item.extendMetaData['destinationAgent']
      const bookingAgent = item.extendMetaData['bookingAgent']
      const xmlParam = `<RequestObject>
      <fileId>${item.fileId}</fileId>
      <extendMetaData>
      <entry>
      <key>documentType</key>
      <value>${documentType}</value>
      </entry>
      <entry>
      <key>documentName</key>
      <value>${documentName}</value>
      </entry>
      <entry>
      <key>isShared</key>
      <value>${isShared}</value>
      </entry>
      <entry>
      <key>op</key>
      <value>${op}</value>
      </entry>
      <entry>
      <key>sales</key>
      <value>${sales}</value>
      </entry>
      <entry>
      <key>all</key>
      <value>${all}</value>
      </entry>
      <entry>
      <key>customer</key>
      <value>${customer}</value>
      </entry>
      <entry>
      <key>consignee</key>
      <value>${consignee}</value>
      </entry>
      <entry>
      <key>shipper</key>
      <value>${shipper}</value>
      </entry>
      <entry>
      <key>destinationAgent</key>
      <value>${destinationAgent}</value>
      </entry>
      <entry>
        <key>bookingAgent</key>
        <value>${bookingAgent}</value>
        </entry>
        </extendMetaData>
        </RequestObject>`
      saveMetaData(xmlParam).then(() => {
        this.toFileQuery()
      })
    },
    // 文件删除
    fileRemove() {
      const rows = this.file.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      // 删除校验
      if (!this.$store.getters.isAdmin) {
        const row = rows.find(p => p.extendMetaData &&
          this.$store.getters.userId !== Number(p.extendMetaData.createdBy) &&
          p.extendMetaData.belong === SystemConstants.FILE_BELONG_INQUIRY.code)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FileFromInquiry'))
          return
        }
      }
      const fileDeleteRole = this.$checkPermission(['button_FileHistory_fileDelete'])
      const ownFileDeleteRole = this.$checkPermission(['role_FileDownloads_ownFileDelete'])
      for (const item of rows) {
        if (!fileDeleteRole && ownFileDeleteRole) {
          if (!item.extendMetaData || (this.$store.getters.userId !== Number(item.extendMetaData.createdBy))) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OwnFileDelete'))
            return
          }
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AYSDF'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        let count = 0
        try {
          for (const item of rows) {
            const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
            if (isSuccess) {
              count++
              item.isDeleted = true
            } else {
              count = 0
              this.$message.error(this.$t('CargoMsg.Cargo_ERF'))
              break
            }
          }
        } finally {
          if (count > 0) this.$message.success(this.$t('CargoMsg.Cargo_FDS'))
          this.file.rowData = this.file.rowData.filter(p => !p.isDeleted)
        }
      }).catch(() => { })
    },
    // 批量下载
    fileDownload() {
      const rows = this.file.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectFilesToDownload'))
        return
      }
      // 判断是否有权限
      if (!this.validate(rows)) {
        return
      }
      if (rows.length === 1) {
        window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.$store.getters.userInfo.sessionId}`)
      } else {
        const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
        const fileName = this.fileCloudFileJob.uuid + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
      }
    },
    // 校验
    validate(fileList) {
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!fileList || fileList.length <= 0) return true
        for (const file of fileList) {
          if (!this.checkDownloadFile(file)) {
            return false
          }
        }
      }
      if (!fileList || fileList.length <= 0) return true
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          return this.checkFileDocTypeRole(file)
        }
      }
      return true
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.file.isShowingDetailForm = true
      const fileObject = this.file.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.file.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent']

      let docTypeFilter = null
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        let documentType = extendMetaData.documentType
        if (documentType === this.$t('Message.Other')) {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (const key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        let keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t(`SeaExport.Accessible`) : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        let keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = this.$t('SeaExport.BookingAgent')
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.file.rowDataFileDetail = tempFileDetailList
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (let i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      const codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        const docObject = this.file.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    // json 根据 key 的名称排序的函数
    objKeySort(obj) {
      const newKey = Object.keys(obj).sort()
      const newObj = {}
      for (let i = 0; i < newKey.length; i++) {
        newObj[newKey[i]] = obj[newKey[i]]
      }
      return newObj
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      let convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
      }
      return convertKeyName
    },
    // 发送邮件
    fileSendEmail() {
      const rows = this.file.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }

      this.file.sendEmailDialog.visible = true
      this.file.sendEmailDialog.emailTitle = Array.from(rows, p => p.fileName).reduce((a, b) => a + ';' + b)
      this.file.sendEmailDialog.fileIdList = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      this.file.sendEmailDialog.fileList = rows
    },
    // 转换文件类型中文名称
    fileTypeLabelFunction: function(value) {
      if (!value) return this.$t('Message.Other')
      let returnVal = ''
      const codes = value.split(',')
      for (let i = 0; i < codes.length; i++) {
        if (returnVal === '') {
          returnVal = this.file.fileTypeMap.get(codes[i]) || this.$t('Message.Other')
        } else {
          returnVal = returnVal + ',' + (this.file.fileTypeMap.get(codes[i]) || this.$t('Message.Other'))
        }
      }
      return returnVal
    },
    // 文件大小转换
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    // 关闭弹框
    handleClose() {
      this.innerVisible = false
    },
    async editStatus(action) {
      // 撤回报价 报价方式为"已有运价"的报价单，无法撤回
      if (action === SystemConstants.QUOTE_ACTION_REVOKE.code &&
        this.quotation.quotationMethod === SystemConstants.QUOTATION_METHOD_HAS_PRICE.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_QuoteMethod_ExistingRate'))
        return
      }
      // 提交报价 之前 先保存
      if (action === SystemConstants.QUOTE_ACTION_SUBMIT.code) {
        const loading = getLoading4Cxt(this)
        try {
          const flag = await this.onSave(false)
          if (!flag) {
            return
          }
        } finally {
          loading.close()
        }
      }
      this.loading = getLoading4Cxt()
      // this.filter.branchId = this.$store.getters.currentOfficeId
      editQuotationStatus({
        uuid: this.quotation.uuid,
        action,
        refuseReason: this.refuseQuotationDialog.refuseReason,
        version: this.quotation.version
      }).then(async res => {
        if (action === SystemConstants.QUOTE_ACTION_REFUSE.code) {
          this.refuseQuotationDialog.refuseReason = ''
          this.refuseQuotationDialog.visible = false
        }
        this.quotation.status2 = res.data
        await this.loadQuotationRelated()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.quotationDetail ::v-deep {
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal;
  }
  .length-weight-height {
    /deep/ .el-input-number {
      width: 59px !important;
    }
  }
}
.el-form{
  .length-weight-height {
    /deep/ .el-input-number {
      width: 59px;
    }
  }
}
</style>
